import {
  faArrowLeft,
  faCheck,
  faCircleXmark,
  faDownload,
  faEye,
  faSearch,
  faTrash,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControl,
  FormControlLabel,
  Input,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Page from "../../component/Page";
import { AGENT_CONFIG } from "./config";
import api from "../../api/api";
import {
  getBranchList,
  getCatalogList,
  getTypesList,
  LocationList,
} from "../setting/services/settingApi";
import { useSelector } from "react-redux";
import { MobileDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { saveAs } from "file-saver";
import DocumentAddon from "./component/documentAddon";
import DocumentAddonExpire from "./component/documentAddonExpire";
import DialogSigner from "./component/dialogSigner";
import {
  downloadFileName,
  fileExtension,
  isExpiredLicenseFile,
} from "./agentFiles";
import Swal from "sweetalert2";
import RequireField from "../../component/RequireField";
import useDebounce from "../../hook/useDebounce";

const BrowserInput = function BrowserInput(props) {
  const {
    inputProps,
    InputProps,
    ownerState,
    value,
    inputRef,
    error,
    ...other
  } = props;
  return (
    <TextField
      {...inputProps}
      ref={inputRef}
      value={
        value
          ? value.substring(0, value?.length - 6) +
            (parseInt(value?.substring(value?.length - 6)) + 543).toString()
          : null
      }
      {...other}
      variant="standard"
      fullWidth
      InputProps={{
        disableUnderline: true,
      }}
    />
  );
};
export default function ViewAgent() {
  const [searchParams, setSearchParams] = useSearchParams();
  let mode = searchParams.get("mode") || "";
  const ExpireFile = [
    {
      name: "สำเนาใบอนุญาตตัวแทนจำหน่ายเมล็ดพันธุ์พืช ของกรมข้าว ที่สิ้นอายุ *",
      value: "ExpiredAgentExtFiles",
      required: true,
      selected: false,
    },
    {
      name: "สำเนาบัตรประจำตัวประชาชน *",
      value: "IdCardExtFiles",
      required: true,
      selected: false,
    },
    {
      name: "สำเนาหนังสือจดทะเบียนเป็นนิติบุคคลหรือทะเบียนพาณิชย์ *",
      value: "JuristicPersonExtFiles",
      required: true,
      selected: false,
    },
    {
      name: "แผนผังแสดงที่อยู่และสถานที่ตั้งของสถานที่จำหน่ายเมล็ด *",
      value: "StoreMapExtFiles",
      required: true,
      selected: false,
    },
    {
      name: "ใบอนุญาตขายเมล็ดพันธุ์ควบคุม (พ.พ.4) *",
      value: "LicenseExtFiles",
      required: true,
      selected: false,
    },
    {
      name: "หนังสือมอบอำนาจ ในกรณีที่ผู้ยื่นคำขอได้รับมอบอำนาจให้ยื่นคำขอต่ออายุแทน",
      value: "ProxyExtFiles",
      required: false,
      selected: false,
    },
  ];
  const TypesFile = [
    {
      name: "สำเนาบัตรประจำตัวประชาชน *",
      value: "IdCardFiles",
      selected: false,
      required: true,
    },
    {
      name: "สำเนาหนังสือจดทะเบียนเป็นนิติบุคคลหรือทะเบียนพาณิชย์ *",
      value: "JuristicPersonFiles",
      selected: false,
      required: true,
    },
    {
      name: "สำเนาใบอนุญาตขายเมล็ดพันธุ์ควบคุม (พ.พ.4) *",
      value: "LicenseFiles",
      selected: false,
      required: true,
    },
    {
      name: "แผนผังแสดงที่อยู่และสถานที่ตั้งของสถานที่จำหน่ายเมล็ดพันธ์ุ *",
      value: "StoreMapFiles",
      selected: false,
      required: true,
    },
    // {
    //     name: 'สำเนาใบอนุญาตตัวแทนจำหน่ายเมล็ดพันธุ์พืช ของกรมข้าว ที่สิ้นอายุ',
    //     value: 'ExpiredAgentExtFiles',
    //     required: false,
    //     selected: false
    // },
    {
      name: "หนังสือมอบอำนาจซึ่งติดอากรแสตมป์ตามกฎหมาย",
      value: "ProxyFiles",
      selected: false,
      required: false,
    },
    {
      name: "เอกสารอื่นๆ",
      value: "OtherFiles",
      selected: false,
      required: false,
    },
  ];

  const { id } = useParams();
  const fileRef = useRef();
  const navigate = useNavigate();
  const [nationalityIdCheck, setNationalityIdCheck] = useState(false);
  const [nationalityIdApiCheck, setNationalityIdApiCheck] = useState(false);
  const [juristicPersonIdError, setJuristicPersonIdError] = useState(false);
  const [juristicPersonIdErrorText, setJuristicPersonIdErrorText] =
    useState("");
  const [juristicPersonIdCheck, setJuristicPersonIdCheck] = useState(false);
  const [juristicPersonIdApiCheck, setJuristicPersonIdApiCheck] =
    useState(false);
  let sAddress = searchParams.get("Address") || "";
  let sCitizenid = searchParams.get("Citizenid") || "";
  let sSex = searchParams.get("Sex") || "";
  let sTh_Firstname = searchParams.get("Th_Firstname") || "";
  let sTh_Lastname = searchParams.get("Th_Lastname") || "";
  let sTh_Prefix = searchParams.get("Th_Prefix") || "";
  let saddrAmphur = searchParams.get("addrAmphur") || "";
  let saddrHouseNo = searchParams.get("addrHouseNo") || "";
  let saddrLane = searchParams.get("addrLane") || "";
  let saddrProvince = searchParams.get("addrProvince") || "";
  let saddrRoad = searchParams.get("addrRoad") || "";
  let saddrTambol = searchParams.get("addrTambol") || "";
  let saddrVillageNo = searchParams.get("addrVillageNo") || "";
  let sbirthday = searchParams.get("birthday") || "";
  const { profile, loading } = useSelector((state) => state.profile);
  const [typesFileSelected, setTypesFileSelected] = useState("");
  const [file, setFile] = useState([]);
  const [filesRemove, setFilesRemove] = useState([]);
  const [signer, setSigner] = useState("");
  const [year, setYear] = useState("");

  const [detail, setDetail] = useState();
  const [approverName, setApproverName] = useState("");
  const [approverNameError, setApproverNameError] = useState(false);
  const [approverTel, setApproverTel] = useState("");
  const [approverTelError, setApproverTelError] = useState(false);
  const [approverOpen, setApproverOpen] = useState(false);
  const [stateFormData, setStateFormData] = useState();

  const [customerName, setCustomerName] = useState("");
  const [customers, setCustomers] = useState([]);
  const [customerData, setCustomerData] = useState();
  const [BranchNo, setBranchsNo] = useState("");
  const [branchs, setBranchs] = useState([]);
  const [agentNumber, setAgentNumber] = useState("");
  const [BirthDate, setBirthDate] = useState();
  const [BirthDateError, setBirthDateError] = useState(false);
  const [Nationality, setNationality] = useState("");
  const [NationalityError, setNationalityError] = useState(false);

  const [refNo, setRefNo] = useState("");
  const [approveDate, setApproveDate] = useState();
  const [juristicPersonType, setJuristicPersonType] = useState("");
  const [juristicPersonId, setJuristicPersonId] = useState("");
  const [authorizedSignatory, setAuthorizedSignatory] = useState();
  const [issuerDate, setIssuerDate] = useState();
  const [personType, setPersonType] = useState("บุคคลธรรมดา");
  const [contactName, setContactName] = useState("");
  const [contactNameError, setContactNameError] = useState(false);
  const [gender, setGender] = useState("นาย");
  const [textGender, setTextGender] = useState("");
  const [customerFName, setCustomerFName] = useState("");
  const [customerFNameError, setCustomerFNameError] = useState(false);
  const [customerLName, setCustomerLName] = useState("");
  const [customerLNameError, setCustomerLNameError] = useState(false);
  const [nationalityId, setNationalityId] = useState("");
  const [nationalityIdError, setNationalityIdError] = useState(false);
  const [nationalityIdErrorText, setNationalityIdErrorText] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [tel, setTel] = useState("");
  const [telError, setTelError] = useState(false);
  const [fax, setFax] = useState("");
  const [OfficeTel, setOfficeTel] = useState("");
  const [OfficeFax, setOfficeFax] = useState("");
  const [ShopTel, setShopTel] = useState("");
  const [ShopFax, setShopFax] = useState("");
  const [houseNumber, setHouseNumber] = useState("");
  const [moo, setMoo] = useState("");
  const [alley, setAlley] = useState("");
  const [address, setAddress] = useState("");
  const [province, setProvince] = useState("");
  const [provinceError, setProvinceError] = useState(false);
  const [value, setValue] = useState({
    ProvinceName: "",
    DistrictName: "",
    SubDistrictName: "",
    Zipcode: "",
  });
  const [valueO, setValueO] = useState({
    ProvinceName: "",
    DistrictName: "",
    SubDistrictName: "",
    Zipcode: "",
  });
  const [valueS, setValueS] = useState({
    ProvinceName: "",
    DistrictName: "",
    SubDistrictName: "",
    Zipcode: "",
  });
  const [valueI, setValueI] = useState({
    ProvinceName: "",
    DistrictName: "",
    SubDistrictName: "",
    Zipcode: "",
  });
  const [district, setDistrict] = useState("");
  const [districtError, setDistrictError] = useState(false);
  const [subDistrict, setSubDistrict] = useState("");
  const [subDistrictError, setSubDistrictError] = useState(false);
  const [zipcode, setZipcode] = useState("");
  const [zipcodeError, setZipcodeError] = useState(false);
  const debouncedSearchP = useDebounce(province, 500);
  const debouncedSearchD = useDebounce(district, 500);
  const debouncedSearchSD = useDebounce(subDistrict, 500);
  const debouncedSearchZ = useDebounce(zipcode, 500);
  const [OfficeHouseNumber, setOfficeHouseNumber] = useState("");
  const [OfficeMoo, setOfficeMoo] = useState("");
  const [OfficeAlley, setOfficeAlley] = useState("");
  const [OfficeAddress, setOfficeAddress] = useState("");
  const [OfficeProvince, setOfficeProvince] = useState("");
  const [OfficeDistrict, setOfficeDistrict] = useState("");
  const [OfficeSubDistrict, setOfficeSubDistrict] = useState("");
  const [OfficeZipcode, setOfficeZipcode] = useState("");
  const debouncedSearchOP = useDebounce(OfficeProvince, 500);
  const debouncedSearchOD = useDebounce(OfficeDistrict, 500);
  const debouncedSearchOSD = useDebounce(OfficeSubDistrict, 500);
  const debouncedSearchOZ = useDebounce(OfficeZipcode, 500);
  const [ShopHouseNumber, setShopHouseNumber] = useState("");
  const [ShopMoo, setShopMoo] = useState("");
  const [ShopAlley, setShopAlley] = useState("");
  const [ShopAddress, setShopAddress] = useState("");
  const [ShopProvince, setShopProvince] = useState("");
  const [ShopProvinceError, setShopProvinceError] = useState(false);
  const [ShopDistrict, setShopDistrict] = useState("");
  const [ShopDistrictError, setShopDistrictError] = useState(false);
  const [IssuerProvince, setIssuerProvince] = useState("");
  const [IssuerDistrict, setIssuerDistrict] = useState("");
  const [ShopSubDistrict, setShopSubDistrict] = useState("");
  const [ShopSubDistrictError, setShopSubDistrictError] = useState(false);
  const [ShopZipcode, setShopZipcode] = useState("");
  const [ShopZipcodeError, setShopZipcodeError] = useState(false);
  const debouncedSearchSP = useDebounce(ShopProvince, 500);
  const debouncedSearchSDi = useDebounce(ShopDistrict, 500);
  const debouncedSearchSSD = useDebounce(ShopSubDistrict, 500);
  const debouncedSearchSZ = useDebounce(ShopZipcode, 500);
  const debouncedSearchIP = useDebounce(IssuerProvince, 500);
  const debouncedSearchID = useDebounce(IssuerDistrict, 500);
  const [locations, setLocations] = useState([]);
  const [locationsO, setLocationsO] = useState([]);
  const [locationsS, setLocationsS] = useState([]);
  const [locationsI, setLocationsI] = useState([]);

  const [ItemTypeName_1, setItemTypeName_1] = useState("");
  const [ItemCatalogName_1, setItemCatalogName_1] = useState("");
  const [ItemSaleAmount_1, setItemSaleAmount_1] = useState("");
  const [ItemTypeName_2, setItemTypeName_2] = useState("");
  const [ItemCatalogName_2, setItemCatalogName_2] = useState("");
  const [ItemSaleAmount_2, setItemSaleAmount_2] = useState("");
  const [ItemTypeName_3, setItemTypeName_3] = useState("");
  const [ItemCatalogName_3, setItemCatalogName_3] = useState("");
  const [ItemSaleAmount_3, setItemSaleAmount_3] = useState("");
  const [ItemTypeName_4, setItemTypeName_4] = useState("");
  const [ItemCatalogName_4, setItemCatalogName_4] = useState("");
  const [ItemSaleAmount_4, setItemSaleAmount_4] = useState("");
  const [Types, setTypes] = useState([]);
  const [Catalog, setCatalog] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [Addon, setAddon] = useState(false);
  const [AddonE, setAddonE] = useState(false);
  const [openS, setOpenS] = useState(false);
  const [openConf, setOpenConf] = useState(false);
  const [actFor, setActFor] = useState();
  const [submitLoading, setSubmitLoading] = useState(false);
  const [AutoExpiredAgentExtFile, setAutoExpiredAgentExtFile] = useState(false);

  const [commercial_registration, setcommercial_registration] = useState("");

  const open = Boolean(anchorEl);
  function Script_checkID(id) {
    if (id.substring(0, 1) == 0) return false;
    if (id.length != 13) return false;
    let sum = 0;
    for (let i = 0; i < 12; i++) sum += parseFloat(id.charAt(i)) * (13 - i);
    if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) return false;
    return true;
  }
  async function getNationality(id) {
    const res = await api.get("nationality-id" + `?id=${id}`);
    const data = res.data;
    if (data.code === 2000 || data.code === 2001) {
      setNationalityIdApiCheck(true);

      if (!textGender) {
        setTextGender(data.result?.titleName);
        setGender(
          data.result?.titleName !== "นาย" &&
            data.result?.titleName !== "นาง" &&
            data.result?.titleName !== "นางสาว"
            ? "อื่นๆ"
            : data.result?.titleName,
        );
      }
      if (!customerFName) {
        setCustomerFName(data.result?.firstName);
      }
      if (!customerLName) {
        setCustomerLName(data.result?.lastName);
      }
      if (!BirthDate) {
        setBirthDate(
          data.result?.dateOfBirth && dayjs(data.result?.dateOfBirth),
        );
      }
      if (!value.ProvinceName) {
        setValue({
          ProvinceName: data.result?.provinceDesc,
          DistrictName: data.result?.districtDesc,
          SubDistrictName: data.result?.subdistrictDesc,
          Zipcode: data.result?.Zipcode || "",
        });
      }
      if (!valueI.ProvinceName) {
        setValueI({
          ProvinceName: data.result?.provinceDesc,
          DistrictName: data.result?.districtDesc,
        });
      }
      if (!address) {
        setAddress(data.result?.roadDesc);
      }
      if (!alley) {
        setAlley(data.result?.alleyDesc);
      }
      if (!houseNumber) {
        setHouseNumber(data.result?.houseNo);
      }
      if (!moo) {
        setMoo(data.result?.villageNo);
      }
      if (!Nationality) {
        setNationality(data.result?.nationalityDesc);
      }
    } else {
      setNationalityIdApiCheck(false);
    }
  }
  async function getNationality2(id) {
    const res = await api.get("nationality-id" + `?id=${id}`);
    const data = res.data;
    if (data.code === 2000 || data.code === 2001) {
      setNationalityIdApiCheck(true);
    } else {
      setNationalityIdApiCheck(false);
    }
  }

  async function getJuristic(id) {
    const res = await api.get("juristic-id" + `?id=${id}`);
    const data = res.data;
    if (data.code === 2000 || data.code === 2001) {
      setJuristicPersonIdApiCheck(true);
      if (!contactName) {
        setContactName(data.result.JuristicName_TH);
      }
      if (!issuerDate) {
        setIssuerDate(
          data.result?.RegisterDate && dayjs(data.result?.RegisterDate),
        );
      }
      if (!juristicPersonType) {
        setJuristicPersonType(data.result?.JuristicType);
      }
      setPersonType("นิติบุคคล");
      if (!textGender) {
        setTextGender(data.result?.CommitteeInformations[0]?.Title);
        setGender(
          data.result?.CommitteeInformations[0]?.Title !== "นาย" &&
            data.result?.CommitteeInformations[0]?.Title !== "นาง" &&
            data.result?.CommitteeInformations[0]?.Title !== "นางสาว"
            ? "อื่นๆ"
            : data.result?.CommitteeInformations[0]?.Title,
        );
      }
      if (!customerFName) {
        setCustomerFName(data.result?.CommitteeInformations[0]?.FirstName);
      }
      if (!customerLName) {
        setCustomerLName(data.result?.CommitteeInformations[0]?.LastName);
      }
      if (!authorizedSignatory) {
        setAuthorizedSignatory(
          data.result?.AuthorizeDescriptions?.filter(
            (x) => x?.Sequence === 1,
          )[0]?.AuthorizeDescription,
        );
      }
      if (!OfficeAddress) {
        setOfficeAddress(data.result?.AddressInformations[0]?.Road);
      }
      if (!OfficeAlley)
        setOfficeAlley(data.result?.AddressInformations[0]?.Soi);
      if (!OfficeHouseNumber) {
        setOfficeHouseNumber(
          data.result?.AddressInformations[0]?.AddressNo ||
            data.result?.AddressInformations[0]?.RoomNo,
        );
      }
      if (!OfficeTel) {
        setOfficeTel(data.result?.AddressInformations[0]?.Phone);
      }
      if (!OfficeMoo) {
        setOfficeMoo(data.result?.AddressInformations[0]?.Moo);
      }
      // setOfficeFax(data.result?.AddressInformations[0]?.)
      if (!valueO.ProvinceName) {
        setValueO({
          ProvinceName: data.result?.AddressInformations[0]?.Province,
          DistrictName: data.result?.AddressInformations[0]?.Ampur,
          SubDistrictName: data.result?.AddressInformations[0]?.Tumbol,
          Zipcode: data.result?.AddressInformations[0]?.Zipcode || "",
        });
      }
    } else {
      setJuristicPersonIdApiCheck(false);
    }
  }
  async function getJuristic2(id) {
    const res = await api.get("juristic-id" + `?id=${id}`);
    const data = res.data;
    if (data.code === 2000 || data.code === 2001) {
      setJuristicPersonIdApiCheck(true);
    }
  }
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getCustomers = async (keyword) => {
    let _params = "";

    if (keyword) {
      _params = "?name=" + keyword;
    }

    const res = await api.get(AGENT_CONFIG.requests.getCustomers.url + _params);
    const data = res.data;
    if (data.status === true) {
      setCustomers(data.result);
    }
  };
  useEffect(() => {
    if (customerName?.length > 1) {
      getCustomers(customerName);
    }
  }, [customerName]);
  useEffect(() => {
    if (customerData) {
      setCustomerFName(customerData?.CustomerFName);
      setCustomerLName(customerData?.CustomerLName);
      setTextGender(customerData?.Title);
      setGender(
        customerData?.Title !== "นาย" &&
          customerData?.Title !== "นาง" &&
          customerData?.Title !== "นางสาว"
          ? "อื่นๆ"
          : customerData?.Title,
      );
      setEmail(customerData?.Email);
      setNationalityId(customerData?.NationalityId);
      setTel(customerData?.Tel);
      setFax(customerData?.Fax);
      setAddress(customerData?.Address);
      setAlley(customerData?.Alley);
      setHouseNumber(customerData?.HouseNumber);
      setMoo(customerData?.Moo);
      setValue({
        ProvinceName: customerData?.Province,
        DistrictName: customerData?.District,
        SubDistrictName: customerData?.SubDistrict,
        Zipcode: customerData?.Zipcode,
      });
      // let files = []
      // if (customerData?.Files.length > 0) {
      //     const _file = customerData?.Files
      //     _file.forEach(x => {
      //         x.typeFile = x.FileName.split('.')?.pop();
      //         const type = TypesFileCustomer.find(c => c.value === x.FileType);
      //         x.typeDoc = type?.name;
      //         x.pathImg = getPathImage(x.typeFile);
      //         x.isNew = false;
      //     })
      //     files = _file;
      // }
      // setFile([...files])
    }
  }, [customerData]);
  async function getAgentDetail() {
    // const newAgentNumber = encodeURIComponent(AgentNumber)
    const url = AGENT_CONFIG.requests.getAgents.url + `/${id}`;
    const res = await api.get(url);
    const data = res.data;
    if (data.status === true) {
      setDetail(data.result);
      setSigner(data.result?.Signer);
      setYear(data.result?.BudgetYear);
      setRefNo(data.result?.RefNo);
      setAgentNumber(data.result?.AgentNumber);
      setBranchsNo(data.result?.BranchNo);
      setApproveDate(
        data.result?.ApproveDate && dayjs(data.result?.ApproveDate),
      );
      setPersonType(data.result?.PersonType);
      setJuristicPersonType(data.result?.JuristicPersonType);
      setJuristicPersonId(data.result?.JuristicPersonId);
      if (data.result?.JuristicPersonId?.length === 13) {
        setJuristicPersonIdCheck(true);
        getJuristic2(data.result?.JuristicPersonId);
      }

      setAuthorizedSignatory(data.result?.AuthorizedSignatory);
      setIssuerDate(data.result?.IssuerDate && dayjs(data.result?.IssuerDate));
      setContactName(data.result.ContactName);
      setValueI({
        ProvinceName: data.result?.IssuerProvince,
        DistrictName: data.result?.IssuerDistrict,
      });
      setBirthDate(data.result?.BirthDate && dayjs(data.result?.BirthDate));
      setNationality(data.result?.Nationality);
      if (data.result?.NationalityId?.length === 13) {
        if (Script_checkID(data.result?.NationalityId)) {
          setNationalityIdCheck(true);
          getNationality2(data.result?.NationalityId);
        }
      }
      setCustomerFName(data.result?.Fname);
      setCustomerLName(data.result?.Lname);
      setTextGender(data.result?.Title);
      setGender(
        data.result?.Title !== "นาย" &&
          data.result?.Title !== "นาง" &&
          data.result?.Title !== "นางสาว"
          ? "อื่นๆ"
          : data.result?.Title,
      );
      setEmail(data.result?.Email);
      setNationalityId(data.result?.NationalityId);
      setTel(data.result?.Tel);
      setFax(data.result?.Fax);
      setAddress(data.result?.Address);
      setAlley(data.result?.Alley);
      setHouseNumber(data.result?.HouseNumber);
      setMoo(data.result?.Moo);
      setValue({
        ProvinceName: data.result?.Province,
        DistrictName: data.result?.District,
        SubDistrictName: data.result?.SubDistrict,
        Zipcode: data.result?.Zipcode,
      });
      setOfficeAddress(data.result?.OfficeAddress);
      setOfficeAlley(data.result?.OfficeAlley);
      setOfficeHouseNumber(data.result?.OfficeHouseNumber);
      setOfficeFax(data.result?.OfficeFax);
      setOfficeTel(data.result?.OfficeTel);
      setOfficeMoo(data.result?.OfficeMoo);
      setValueO({
        ProvinceName: data.result?.OfficeProvince,
        DistrictName: data.result?.OfficeDistrict,
        SubDistrictName: data.result?.OfficeSubDistrict,
        Zipcode: data.result?.OfficeZipcode,
      });
      setShopAddress(data.result?.ShopAddress);
      setShopAlley(data.result?.ShopAlley);
      setShopHouseNumber(data.result?.ShopHouseNumber);
      setShopFax(data.result?.ShopFax);
      setShopTel(data.result?.ShopTel);
      setShopMoo(data.result?.ShopMoo);
      setValueS({
        ProvinceName: data.result?.ShopProvince,
        DistrictName: data.result?.ShopDistrict,
        SubDistrictName: data.result?.ShopSubDistrict,
        Zipcode: data.result?.ShopZipcode,
      });
      setItemCatalogName_1(data.result?.ItemCatalogName_1);
      setItemSaleAmount_1(data.result?.ItemSaleAmount_1);
      setItemTypeName_1(data.result?.ItemTypeName_1);
      setItemCatalogName_2(data.result?.ItemCatalogName_2);
      setItemSaleAmount_2(data.result?.ItemSaleAmount_2);
      setItemTypeName_2(data.result?.ItemTypeName_2);
      setItemCatalogName_3(data.result?.ItemCatalogName_3);
      setItemSaleAmount_3(data.result?.ItemSaleAmount_3);
      setItemTypeName_3(data.result?.ItemTypeName_3);
      setItemCatalogName_4(data.result?.ItemCatalogName_4);
      setItemSaleAmount_4(data.result?.ItemSaleAmount_4);
      setItemTypeName_4(data.result?.ItemTypeName_4);
      //   setAutoExpiredAgentExtFile(data.result?.AutoExpiredAgentExtFile);
      let files = [];
      if (data.result) {
        if (mode) {
          if (data.result?.ExtentionFiles?.length > 0) {
            const _file = data.result?.ExtentionFiles;
            _file.forEach((x) => {
              x.typeFile = fileExtension(x);
              const type = ExpireFile.find((c) => c.value === x.FileType);
              x.typeDoc = type?.name;
              x.pathImg = getPathImage(x.typeFile);
              x.isNew = false;
            });
            files = _file;
          }
        } else {
          if (data.result?.Files.length > 0) {
            const _file = data.result?.Files;
            _file.forEach((x) => {
              x.typeFile = fileExtension(x);
              const type = TypesFile.find((c) => c.value === x.FileType);
              x.typeDoc = type?.name;
              x.pathImg = getPathImage(x.typeFile);
              x.isNew = false;
            });
            files = _file;
          }
        }
      }

      setFile([...files]);
    }
  }
  useEffect(() => {
    if (id) {
      getAgentDetail();
    }
    if (!id) {
      const datenow = new Date().getFullYear();
      const BirthDay = new Date(sbirthday);
      const day = BirthDay.getDate();
      const month = BirthDay.getMonth();
      const year = BirthDay.getFullYear() - 543;
      let age = datenow - year;

      if (sTh_Prefix) {
        setTextGender(sTh_Prefix === "น.ส." ? "นางสาว" : sTh_Prefix);
        setGender(
          sTh_Prefix !== "นาย" && sTh_Prefix !== "นาง" && sTh_Prefix !== "น.ส."
            ? "อื่นๆ"
            : sTh_Prefix === "น.ส."
              ? "นางสาว"
              : sTh_Prefix,
        );
      }
      if (sTh_Firstname) {
        setCustomerFName(sTh_Firstname);
      }
      if (sTh_Lastname) {
        setCustomerLName(sTh_Lastname);
      }
      setContactName(
        sTh_Firstname && sTh_Lastname ? `${sTh_Firstname} ${sTh_Lastname}` : "",
      );
      if (sCitizenid) {
        setNationalityId(sCitizenid);
      }
      if (sbirthday) {
        setBirthDate(dayjs(sbirthday));
      }
      if (saddrRoad) {
        setAddress(saddrRoad);
      }

      let newsaddrAmphur = saddrAmphur;
      let newsaddrTambol = saddrTambol;
      setValue({
        ProvinceName:
          saddrProvince &&
          (saddrProvince?.startsWith("จังหวัด")
            ? saddrProvince.slice("จังหวัด".length)
            : saddrProvince),
        DistrictName:
          saddrAmphur &&
          (saddrAmphur?.startsWith("อำเภอ")
            ? newsaddrAmphur.slice("อำเภอ".length)
            : saddrAmphur?.startsWith("เขต")
              ? newsaddrAmphur.slice("เขต".length)
              : saddrAmphur),
        SubDistrictName:
          saddrTambol &&
          (saddrTambol?.startsWith("ตำบล")
            ? newsaddrTambol.slice("ตำบล".length)
            : saddrTambol?.startsWith("แขวง")
              ? newsaddrTambol.slice("แขวง".length)
              : saddrTambol),
        Zipcode: "",
      });
      if (saddrHouseNo) {
        setHouseNumber(saddrHouseNo);
      }
      if (saddrVillageNo) {
        setMoo(
          saddrVillageNo &&
            (saddrVillageNo?.startsWith("หมู่ที่ ")
              ? saddrVillageNo.slice("หมู่ที่ ".length)
              : saddrVillageNo?.startsWith("หมู่ที่")
                ? saddrVillageNo.slice("หมู่ที่".length)
                : saddrVillageNo),
        );
      }
    }
    getBranchList(null, setBranchs);
    getTypesList(null, setTypes);
    getCatalogList(null, setCatalog);
    if (mode) {
      setTypesFileSelected(ExpireFile[0].value);
    } else {
      setTypesFileSelected(TypesFile[0].value);
    }
    const body = {
      typeSearch: "",
      Text: "",
    };
    LocationList(body, setLocationsI);
    LocationList(body, setLocations);
    LocationList(body, setLocationsO);
    LocationList(body, setLocationsS);
  }, []);

  useEffect(() => {
    if (profile) {
      setBranchsNo(profile?.BranchNo?.BranchNo);
    }
  }, [profile]);

  useEffect(() => {
    if (debouncedSearchIP.length >= 0) {
      const body = {
        typeSearch: "P",
        Text: debouncedSearchIP,
      };
      LocationList(body, setLocationsI);
    }
    if (debouncedSearchID.length >= 0) {
      const body = {
        typeSearch: "D",
        Text: debouncedSearchID,
      };
      LocationList(body, setLocationsI);
    }
  }, [debouncedSearchIP, debouncedSearchID]);
  useEffect(() => {
    if (debouncedSearchP.length >= 0) {
      const body = {
        typeSearch: "P",
        Text: debouncedSearchP,
      };
      LocationList(body, setLocations);
    }
    if (debouncedSearchD.length >= 0) {
      const body = {
        typeSearch: "D",
        Text: debouncedSearchD,
      };
      LocationList(body, setLocations);
    }
    if (debouncedSearchSD.length >= 0) {
      const body = {
        typeSearch: "SD",
        Text: debouncedSearchSD,
      };
      LocationList(body, setLocations);
    }
    if (debouncedSearchZ.length >= 0) {
      const body = {
        typeSearch: "Z",
        Text: debouncedSearchZ,
      };
      LocationList(body, setLocations);
    }
  }, [debouncedSearchP, debouncedSearchD, debouncedSearchSD, debouncedSearchZ]);
  useEffect(() => {
    if (debouncedSearchOP.length >= 0) {
      const body = {
        typeSearch: "P",
        Text: debouncedSearchOP,
      };
      LocationList(body, setLocationsO);
    }
    if (debouncedSearchOD.length >= 0) {
      const body = {
        typeSearch: "D",
        Text: debouncedSearchOD,
      };
      LocationList(body, setLocationsO);
    }
    if (debouncedSearchOSD.length >= 0) {
      const body = {
        typeSearch: "SD",
        Text: debouncedSearchOSD,
      };
      LocationList(body, setLocationsO);
    }
    if (debouncedSearchOZ.length >= 0) {
      const body = {
        typeSearch: "Z",
        Text: debouncedSearchOZ,
      };
      LocationList(body, setLocationsO);
    }
  }, [
    debouncedSearchOP,
    debouncedSearchOD,
    debouncedSearchOSD,
    debouncedSearchOZ,
  ]);
  useEffect(() => {
    if (debouncedSearchSP.length >= 0) {
      const body = {
        typeSearch: "P",
        Text: debouncedSearchSP,
      };
      LocationList(body, setLocationsS);
    }
    if (debouncedSearchSDi.length >= 0) {
      const body = {
        typeSearch: "D",
        Text: debouncedSearchSDi,
      };
      LocationList(body, setLocationsS);
    }
    if (debouncedSearchSSD.length >= 0) {
      const body = {
        typeSearch: "SD",
        Text: debouncedSearchSSD,
      };
      LocationList(body, setLocationsS);
    }
    if (debouncedSearchSZ.length >= 0) {
      const body = {
        typeSearch: "Z",
        Text: debouncedSearchSZ,
      };
      LocationList(body, setLocationsS);
    }
  }, [
    debouncedSearchSP,
    debouncedSearchSDi,
    debouncedSearchSSD,
    debouncedSearchSZ,
  ]);
  const getPathImage = (extension) => {
    if (extension === "png") {
      return "assets/icons/png.svg";
    } else if (extension === "jpg") {
      return "assets/icons/jpg.svg";
    } else if (extension === "pdf") {
      return "assets/icons/pdf.svg";
    } else if (extension === "doc") {
      return "assets/icons/doc.svg";
    } else if (extension === "txt") {
      return "assets/icons/txt.svg";
    } else if (extension === "zip") {
      return "assets/icons/zip.svg";
    } else if (extension === "xls" || extension === "xlsx") {
      return "assets/icons/xls.svg";
    } else {
      return "assets/icons/file.svg";
    }
  };
  async function uploadFile(event) {
    if (event.target.files && event.target.files?.length) {
      const files = event.target.files[0];
      const extension = files.name.split(".")?.pop();
      const pathImg = getPathImage(extension);
      let type = null;
      if (mode) {
        type = ExpireFile.find((c) => c.value === typesFileSelected);
      } else {
        type = TypesFile.find((c) => c.value === typesFileSelected);
      }

      const fileUpload = {
        Category: "Agent",
        CategoryRefNo: null,
        FileName: files.name,
        FilePath: null,
        typeDoc: type.name,
        FileType: type.value,
        pathImg: pathImg,
        typeFile: extension,
        UploadFileId: null,
        File: files,
        isNew: true,
      };
      setFile([...file, fileUpload]);
      event.target.value = null;
    }
  }
  const agentAdd = async (formdata, RequestNo) => {
    if (RequestNo) {
      setSubmitLoading(true);
      // const newAgentNumber = encodeURIComponent(AgentNumber)
      const url = AGENT_CONFIG.requests.getAgents.url + `/${RequestNo}`;
      const res = await api.put(url, formdata);
      const data = res.data;
      if (data.status === true) {
        // ไฟล์ใบอนุญาตเดิมถูกสร้างไปแล้วในรอบนี้ ถ้าค้างไว้ การบันทึกครั้งต่อไป (เช่นแก้ไขหลังต่ออายุ)
        // จะสร้างจากใบอนุญาตใบใหม่แทนใบที่สิ้นอายุ
        setAutoExpiredAgentExtFile(false);
        getAgentDetail();

        Swal.fire("บันทึกข้อมูลตัวแทนสำเร็จ", "", "success");
        if (mode) {
          navigate("/agent/agent-list/" + data.result.RequestNo);
        }
        setSubmitLoading(false);
      } else {
        Swal.fire({
          title:
            data?.message || data?.code === 2003
              ? "บันทึกข้อมูลไม่สำเร็จ มีข้อมูลนี้ในระบบแล้ว"
              : "ทำรายการไม่สำเร็จ",
          icon: "warning",
        });
        setSubmitLoading(false);
      }
    } else {
      setSubmitLoading(true);

      const res = await api.post(AGENT_CONFIG.requests.getAgents.url, formdata);
      const data = res.data;
      if (data.status === true) {
        navigate("/agent/agent-list/" + data.result.RequestNo);

        Swal.fire("บันทึกข้อมูลตัวแทนสำเร็จ", "", "success");
        setSubmitLoading(false);
      } else {
        Swal.fire({
          title:
            data?.message || data?.code === 2003
              ? "บันทึกข้อมูลไม่สำเร็จ มีข้อมูลนี้ในระบบแล้ว"
              : "ทำรายการไม่สำเร็จ",
          icon: "warning",
        });
        setSubmitLoading(false);
      }
    }
  };

  const handleSubmit = async (status) => {
    const frmData = new FormData();

    // this.loading.submit = true;
    // const _AgentNumber = this.agent ? this.agent?.AgentNumber : undefined;
    // const _RequestNo = this.agent ? this.agent?.RequestNo : undefined;
    const addFiles = file.length > 0 ? file.filter((x) => x.isNew) : [];
    if (filesRemove.length > 0) {
      const _remove = {
        FileIDs: filesRemove,
      };
      await FremoveFiles(_remove);
      setFilesRemove([]);
    }

    if (addFiles.length > 0) {
      for (const c of addFiles) {
        frmData.append(c?.FileType, c?.File);
      }
    }

    if (detail) {
      frmData.append("AgentId", detail?.AgentId.toString());
    }
    if (refNo) {
      frmData.append("RefNo", refNo);
    }
    if (approveDate) {
      const ApproveDate = dayjs(approveDate).format("YYYY-MM-DD");
      frmData.append("ApproveDate", ApproveDate);
    }
    if (agentNumber) {
      frmData.append("AgentNumber", agentNumber);
    }
    if (id) {
      frmData.append("RequestNo", id);
    }
    if (approverName) {
      frmData.append("ApproverName", approverName);
    }
    if (approverTel) {
      frmData.append("ApproverTel", approverTel);
    }
    frmData.append("BranchNo", BranchNo);
    frmData.append("Email", email);
    frmData.append("Fname", customerFName);
    frmData.append("Lname", customerLName);
    if (BirthDate) {
      frmData.append("BirthDate", dayjs(BirthDate).format("YYYY-MM-DD"));
    }
    frmData.append("Nationality", Nationality || "");

    frmData.append("NationalityId", nationalityId || "");

    frmData.append("ShopAlley", ShopAlley || "");

    if (contactName) {
      frmData.append("ContactName", contactName);
    }

    frmData.append("Alley", alley || "");

    frmData.append("Moo", moo || "");

    frmData.append("Address", address || "");

    frmData.append("HouseNumber", houseNumber || "");

    frmData.append("Province", value.ProvinceName);
    frmData.append("District", value.DistrictName);
    frmData.append("SubDistrict", value.SubDistrictName);
    frmData.append("Zipcode", value.Zipcode);

    frmData.append("ShopHouseNumber", ShopHouseNumber || "");

    frmData.append("ShopMoo", ShopMoo || "");

    frmData.append("ShopAddress", ShopAddress || "");

    frmData.append("Title", textGender);
    frmData.append("ShopProvince", valueS.ProvinceName || "");
    frmData.append("ShopDistrict", valueS.DistrictName || "");
    frmData.append("ShopSubDistrict", valueS.SubDistrictName || "");
    frmData.append("ShopZipcode", valueS.Zipcode || "");
    frmData.append("ShopTel", ShopTel || "");
    frmData.append("ShopFax", ShopFax || "");

    frmData.append("IssuerDistrict", valueI.DistrictName || "");
    frmData.append("IssuerProvince", valueI.ProvinceName || "");

    frmData.append("IssuerDate", dayjs(issuerDate).format("YYYY-MM-DD"));

    frmData.append("PersonType", personType || "");
    frmData.append("JuristicPersonType", juristicPersonType || "");
    frmData.append("JuristicPersonId", juristicPersonId || "");
    frmData.append("AuthorizedSignatory", authorizedSignatory || "");

    frmData.append("OfficeHouseNumber", OfficeHouseNumber || "");
    frmData.append("OfficeMoo", OfficeMoo || "");
    frmData.append("OfficeAddress", OfficeAddress || "");
    frmData.append("OfficeProvince", valueO.ProvinceName || "");
    frmData.append("OfficeDistrict", valueO.DistrictName || "");
    frmData.append("OfficeSubDistrict", valueO.SubDistrictName || "");
    frmData.append("OfficeZipcode", valueO.Zipcode || "");
    frmData.append("OfficeTel", OfficeTel || "");
    frmData.append("OfficeFax", OfficeFax || "");

    frmData.append("ItemTypeName_1", ItemTypeName_1 || "");
    frmData.append("ItemCatalogName_1", ItemCatalogName_1 || "");
    frmData.append("ItemSaleAmount_1", +ItemSaleAmount_1 || 0);

    frmData.append("ItemTypeName_2", ItemTypeName_2 || "");
    frmData.append("ItemCatalogName_2", ItemCatalogName_2 || "");
    frmData.append("ItemSaleAmount_2", +ItemSaleAmount_2 || 0);

    frmData.append("ItemTypeName_3", ItemTypeName_3 || "");
    frmData.append("ItemCatalogName_3", ItemCatalogName_3 || "");
    frmData.append("ItemSaleAmount_3", +ItemSaleAmount_3 || 0);

    frmData.append("ItemTypeName_4", ItemTypeName_4 || "");
    frmData.append("ItemCatalogName_4", ItemCatalogName_4 || "");
    frmData.append("ItemSaleAmount_4", +ItemSaleAmount_4 || 0);

    frmData.append("Tel", tel);
    frmData.append("AutoExpiredAgentExtFile", AutoExpiredAgentExtFile);
    if (fax) {
      frmData.append("Fax", fax);
    }

    if (detail && (status === "Y" || status === "N")) {
      frmData.append("Status", status);
    }

    // const _Status = this.agent && this.agent?.Status === StockStatus.Active ? StockStatus.Active : status;
    // frmData.append('Status', _Status);

    // const res: IAgent = await this.agentService.AgentAdd(frmData, _RequestNo);
    // this.loading.submit = false;
    // if (res) {

    //   if (!this.agent) {
    //     this.AgentNumber = res?.AgentNumber
    //     this.router.navigate(['/agent/agent-list']);

    //   }
    //   await this.ngOnInit();
    // }

    // if ((status === StockStatus.Active || status === StockStatus.Waiting || status === StockStatus.Inactive) && this.agent) {
    //   await this.ngOnInit();
    // }

    const IdCardFiles = file.filter((x) => x.FileType === "IdCardFiles");
    const JuristicPersonFiles = file.filter(
      (x) => x.FileType === "JuristicPersonFiles",
    );
    const LicenseFiles = file.filter((x) => x.FileType === "LicenseFiles");
    const StoreMapFiles = file.filter((x) => x.FileType === "StoreMapFiles");

    const ExpiredAgentExtFiles = file.filter(isExpiredLicenseFile);
    const IdCardExtFiles = file.filter((x) => x.FileType === "IdCardExtFiles");
    const JuristicPersonExtFiles = file.filter(
      (x) => x.FileType === "JuristicPersonExtFiles",
    );
    const StoreMapExtFiles = file.filter(
      (x) => x.FileType === "StoreMapExtFiles",
    );
    const LicenseExtFiles = file.filter(
      (x) => x.FileType === "LicenseExtFiles",
    );

    if (contactName.length === 0) {
      setContactNameError(true);
    }
    if (customerFName.length === 0) {
      setCustomerFNameError(true);
    }
    if (customerLName.length === 0) {
      setCustomerLNameError(true);
    }
    if (Nationality.length === 0) {
      setNationalityError(true);
    }
    if (nationalityId.length === 0) {
      setNationalityIdError(true);
      setNationalityIdErrorText("กรุณากรอกบัตรประจำตัวประชาชน");
    }
    if (juristicPersonId?.length === 0 && personType === "นิติบุคคล") {
      setJuristicPersonIdError(true);
      setJuristicPersonIdErrorText("กรุณากรอกเลขที่นิติบุคคล");
    }
    if (juristicPersonId?.length === 0 && personType !== "นิติบุคคล") {
      setJuristicPersonIdError(true);
      setJuristicPersonIdErrorText("กรุณากรอกทะเบียนพาณิชย์");
    }
    if (tel.length === 0) {
      setTelError(true);
    }
    if (email.length === 0) {
      setEmailError(true);
    }
    if (!BirthDate) {
      setBirthDateError(true);
    }
    if (province.length === 0) {
      setProvinceError(true);
    }
    if (district.length === 0) {
      setDistrictError(true);
    }
    if (subDistrict.length === 0) {
      setSubDistrictError(true);
    }
    if (zipcode.length === 0) {
      setZipcodeError(true);
    }
    if (ShopProvince.length === 0) {
      setShopProvinceError(true);
    }
    if (ShopDistrict.length === 0) {
      setShopDistrictError(true);
    }
    if (ShopSubDistrict.length === 0) {
      setShopSubDistrictError(true);
    }
    if (ShopZipcode.length === 0) {
      setShopZipcodeError(true);
    }
    if (
      contactName.length > 0 &&
      customerFName.length > 0 &&
      customerLName.length > 0 &&
      Nationality.length > 0 &&
      nationalityId.length > 0 &&
      (personType === "นิติบุคคล" ? juristicPersonId.length > 0 : true) &&
      tel.length > 0 &&
      email.length > 0 &&
      BirthDate &&
      province.length > 0 &&
      district.length > 0 &&
      subDistrict.length > 0 &&
      zipcode.length > 0 &&
      ShopProvince.length > 0 &&
      ShopDistrict.length > 0 &&
      ShopSubDistrict.length > 0 &&
      ShopZipcode.length > 0
    ) {
      if (!mode) {
        if (
          file.length === 0 ||
          IdCardFiles.length === 0 ||
          JuristicPersonFiles.length === 0 ||
          LicenseFiles.length === 0 ||
          StoreMapFiles.length === 0
        ) {
          // return this.alertService.alertError('กรุณาอัพโหลดเอกสารที่จำเป็นในการสมัครให้ครบถ้วน');
          Swal.fire(
            "กรุณาอัพโหลดเอกสารที่จำเป็นในการสมัครให้ครบถ้วน",
            "",
            "warning",
          );
        } else {
          if (!status) {
            // await this.ConfirmDialogSubmit(frmData, id);
            // agentAdd(frmData, id)
            setOpenConf(true);
            setStateFormData(frmData);
          } else {
            if (status === "Y") {
              if (!approverName) {
                return setApproverNameError(true);
              }
              if (!approverTel) {
                return setApproverTelError(true);
              }
              Swal.fire({
                title: "ยืนยันการอนุมัติ",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#4ab866",
                cancelButtonColor: "#d33",
              }).then((result) => {
                if (result.isConfirmed) {
                  agentAdd(frmData, id);
                  setApproverName("");
                  setApproverTel("");
                  setApproverNameError(false);
                  setApproverTelError(false);
                  setApproverOpen(false);
                }
              });
            } else {
              Swal.fire({
                title: "ยืนยันการไม่อนุมัติ",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#4ab866",
                cancelButtonColor: "#d33",
              }).then((result) => {
                if (result.isConfirmed) {
                  agentAdd(frmData, id);
                }
              });
              // this.loading.submit = true;
              // const res: IAgent = await this.agentService.AgentAdd(frmData, _RequestNo, this.agent?.AgentId);
              // await this.ngOnInit();
              // this.loading.submit = false;
            }
          }
        }
      } else {
        if (
          file.length === 0 ||
          (AutoExpiredAgentExtFile
            ? false
            : ExpiredAgentExtFiles.length === 0) ||
          IdCardExtFiles.length === 0 ||
          JuristicPersonExtFiles.length === 0 ||
          StoreMapExtFiles.length === 0 ||
          LicenseExtFiles.length === 0
        ) {
          Swal.fire(
            "กรุณาอัพโหลดเอกสารที่จำเป็นในการต่ออายุให้ครบถ้วน",
            "",
            "warning",
          );

          // return this.alertService.alertError('กรุณาอัพโหลดเอกสารที่จำเป็นในการต่ออายุให้ครบถ้วน');
        } else {
          if (!status) {
            // await this.ConfirmDialogSubmit(frmData, id);
            // agentAdd(frmData, id)
            // เดิมหน้าต่ออายุไม่ได้เก็บ FormData ไว้ให้ dialog ยืนยัน ปุ่มแก้ไขจึงส่งข้อมูลว่างแล้วบันทึกไม่ได้
            // ผู้ใช้เลยต้องกด "ต่ออายุ" แทน ซึ่งเป็นการอนุมัติ ระบบจึงออกเลขที่เอกสารใหม่
            setStateFormData(frmData);
            setOpenConf(true);
          }
        }
      }
    }
  };
  const EditWhenApprove = async () => {
    // this.loading.submit = true;
    // const _AgentNumber = this.agent ? this.agent?.AgentNumber : undefined;
    // const _RequestNo = this.agent ? this.agent?.RequestNo : undefined;
    const frmData = new FormData();
    const addFiles = file.length > 0 ? file.filter((x) => x.isNew) : [];
    if (filesRemove.length > 0) {
      const _remove = {
        FileIDs: filesRemove,
      };
      await FremoveFiles(_remove);
      setFilesRemove([]);
    }

    if (addFiles.length > 0) {
      for (const c of addFiles) {
        frmData.append(c?.FileType, c?.File);
      }
    }

    if (detail) {
      frmData.append("AgentId", detail?.AgentId.toString());
    }
    if (refNo) {
      frmData.append("RefNo", refNo);
    }
    if (approveDate) {
      const ApproveDate = dayjs(approveDate).format("YYYY-MM-DD");
      frmData.append("ApproveDate", ApproveDate);
    }
    if (agentNumber) {
      frmData.append("AgentNumber", agentNumber);
    }
    if (id) {
      frmData.append("RequestNo", id);
    }

    frmData.append("BranchNo", BranchNo);
    frmData.append("Email", email);
    frmData.append("Fname", customerFName);
    frmData.append("Lname", customerLName);
    if (BirthDate) {
      frmData.append("BirthDate", dayjs(BirthDate).format("YYYY-MM-DD"));
    }
    frmData.append("Nationality", Nationality || "");

    frmData.append("NationalityId", nationalityId || "");

    frmData.append("ShopAlley", ShopAlley || "");

    if (contactName) {
      frmData.append("ContactName", contactName);
    }

    frmData.append("Alley", alley || "");

    frmData.append("Moo", moo || "");

    frmData.append("Address", address || "");

    frmData.append("HouseNumber", houseNumber || "");

    frmData.append("Province", value.ProvinceName);
    frmData.append("District", value.DistrictName);
    frmData.append("SubDistrict", value.SubDistrictName);
    frmData.append("Zipcode", value.Zipcode);

    frmData.append("ShopHouseNumber", ShopHouseNumber || "");

    frmData.append("ShopMoo", ShopMoo || "");

    frmData.append("ShopAddress", ShopAddress || "");

    frmData.append("Title", textGender);
    frmData.append("ShopProvince", valueS.ProvinceName || "");
    frmData.append("ShopDistrict", valueS.DistrictName || "");
    frmData.append("ShopSubDistrict", valueS.SubDistrictName || "");
    frmData.append("ShopZipcode", valueS.Zipcode || "");
    frmData.append("ShopTel", ShopTel || "");
    frmData.append("ShopFax", ShopFax || "");

    frmData.append("IssuerDistrict", valueI.DistrictName || "");
    frmData.append("IssuerProvince", valueI.ProvinceName || "");

    frmData.append("IssuerDate", dayjs(issuerDate).format("YYYY-MM-DD"));

    frmData.append("PersonType", personType || "");
    frmData.append("JuristicPersonType", juristicPersonType || "");
    frmData.append("JuristicPersonId", juristicPersonId || "");
    frmData.append("AuthorizedSignatory", authorizedSignatory || "");

    frmData.append("OfficeHouseNumber", OfficeHouseNumber || "");
    frmData.append("OfficeMoo", OfficeMoo || "");
    frmData.append("OfficeAddress", OfficeAddress || "");
    frmData.append("OfficeProvince", valueO.ProvinceName || "");
    frmData.append("OfficeDistrict", valueO.DistrictName || "");
    frmData.append("OfficeSubDistrict", valueO.SubDistrictName || "");
    frmData.append("OfficeZipcode", valueO.Zipcode || "");
    frmData.append("OfficeTel", OfficeTel || "");
    frmData.append("OfficeFax", OfficeFax || "");

    frmData.append("ItemTypeName_1", ItemTypeName_1 || "");
    frmData.append("ItemCatalogName_1", ItemCatalogName_1 || "");
    frmData.append("ItemSaleAmount_1", +ItemSaleAmount_1 || 0);

    frmData.append("ItemTypeName_2", ItemTypeName_2 || "");
    frmData.append("ItemCatalogName_2", ItemCatalogName_2 || "");
    frmData.append("ItemSaleAmount_2", +ItemSaleAmount_2 || 0);

    frmData.append("ItemTypeName_3", ItemTypeName_3 || "");
    frmData.append("ItemCatalogName_3", ItemCatalogName_3 || "");
    frmData.append("ItemSaleAmount_3", +ItemSaleAmount_3 || 0);

    frmData.append("ItemTypeName_4", ItemTypeName_4 || "");
    frmData.append("ItemCatalogName_4", ItemCatalogName_4 || "");
    frmData.append("ItemSaleAmount_4", +ItemSaleAmount_4 || 0);
    frmData.append("AutoExpiredAgentExtFile", AutoExpiredAgentExtFile);

    frmData.append("Tel", tel);
    if (fax) {
      frmData.append("Fax", fax);
    }

    frmData.append("ApproveExtention", "true");
    frmData.append("Status", "Y");

    if (contactName.length === 0) {
      setContactNameError(true);
    }
    if (customerFName.length === 0) {
      setCustomerFNameError(true);
    }
    if (customerLName.length === 0) {
      setCustomerLNameError(true);
    }
    if (Nationality.length === 0) {
      setNationalityError(true);
    }
    if (nationalityId.length === 0) {
      setNationalityIdError(true);
      setNationalityIdErrorText("กรุณากรอกบัตรประจำตัวประชาชน");
    }
    if (juristicPersonId.length === 0 && personType === "นิติบุคคล") {
      setJuristicPersonIdError(true);
      setJuristicPersonIdErrorText("กรุณากรอกเลขที่นิติบุคคล");
    }
    if (juristicPersonId?.length === 0 && personType !== "นิติบุคคล") {
      setJuristicPersonIdError(true);
      setJuristicPersonIdErrorText("กรุณากรอกทะเบียนพาณิชย์");
    }
    if (tel.length === 0) {
      setTelError(true);
    }
    if (email.length === 0) {
      setEmailError(true);
    }
    if (!BirthDate) {
      setBirthDateError(true);
    }
    if (province.length === 0) {
      setProvinceError(true);
    }
    if (district.length === 0) {
      setDistrictError(true);
    }
    if (subDistrict.length === 0) {
      setSubDistrictError(true);
    }
    if (zipcode.length === 0) {
      setZipcodeError(true);
    }
    if (ShopProvince.length === 0) {
      setShopProvinceError(true);
    }
    if (ShopDistrict.length === 0) {
      setShopDistrictError(true);
    }
    if (ShopSubDistrict.length === 0) {
      setShopSubDistrictError(true);
    }
    if (ShopZipcode.length === 0) {
      setShopZipcodeError(true);
    }
    if (
      contactName.length > 0 &&
      customerFName.length > 0 &&
      customerLName.length > 0 &&
      Nationality.length > 0 &&
      nationalityId.length > 0 &&
      (personType === "นิติบุคคล" ? juristicPersonId.length > 0 : true) &&
      tel.length > 0 &&
      email.length > 0 &&
      BirthDate &&
      province.length > 0 &&
      district.length > 0 &&
      subDistrict.length > 0 &&
      zipcode.length > 0 &&
      ShopProvince.length > 0 &&
      ShopDistrict.length > 0 &&
      ShopSubDistrict.length > 0 &&
      ShopZipcode.length > 0
    ) {
      agentAdd(frmData, id);
    }
  };
  async function downloadFile(file) {
    const url =
      AGENT_CONFIG.requests.downloadFile.url + `/${file?.UploadFileId}`;
    const res = await api.get(url, {
      responseType: "arraybuffer",
    });
    const blob = new Blob([res.data]);
    // const blobUrl = URL.createObjectURL(blob);

    // window.open(blobUrl, '_blank');
    saveAs(blob, downloadFileName(file));
  }
  async function viewFile(file) {
    const url =
      AGENT_CONFIG.requests.downloadFile.url + `/${file?.UploadFileId}`;
    const res = await api.get(url, {
      responseType: "arraybuffer",
    });
    if (file?.typeFile === "jpeg") {
      const blob = new Blob([res.data], { type: `image/${file?.typeFile}` });
      const blobUrl = URL.createObjectURL(blob);

      window.open(blobUrl, "_blank");
    } else if (file?.typeFile === "jpg") {
      const blob = new Blob([res.data], { type: `image/${file?.typeFile}` });
      const blobUrl = URL.createObjectURL(blob);

      window.open(blobUrl, "_blank");
    } else if (file?.typeFile === "png") {
      const blob = new Blob([res.data], { type: `image/${file?.typeFile}` });
      const blobUrl = URL.createObjectURL(blob);

      window.open(blobUrl, "_blank");
    } else if (file?.typeFile === "pdf") {
      const blob = new Blob([res.data], { type: `application/pdf` });
      const blobUrl = URL.createObjectURL(blob);

      window.open(blobUrl, "_blank");
    } else {
      const blob = new Blob([res.data]);
      saveAs(blob, downloadFileName(file));
    }
  }
  async function FremoveFiles(fileRemove) {
    const res = await api.put(
      AGENT_CONFIG.requests.removeFiles.url,
      fileRemove,
    );
  }

  async function addon() {
    // const typeFiles = await this.documentService.GetTypeFileUpload();
    // typeFiles.map(x => x.selected = false);
    setAddon(true);
  }

  async function addonExpire() {
    // const typeFiles = await this.documentService.GetTypeFileUpload();
    // typeFiles.map(x => x.selected = false);
    setAddonE(true);
  }
  function openDialogSigner(actFor) {
    setOpenS(true);
    setActFor(actFor);
  }

  const [downloadFormAgent, setdownloadFormAgent] = useState(false);
  async function downLoadRegister() {
    setAnchorEl(null);
    setdownloadFormAgent(true);
    const res = await api.get(
      AGENT_CONFIG.requests.getAgents.url + `/${id}/register/pdf`,
      {
        responseType: "arraybuffer",
      },
    );
    const buffer = res.data;
    const blob = new Blob([buffer], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
    setdownloadFormAgent(false);
  }

  async function downloadExtensionExpire() {
    setAnchorEl(null);
    setdownloadFormAgent(true);
    const newNumber = encodeURIComponent(detail?.AgentNumber);

    const res = await api.get(
      AGENT_CONFIG.requests.getAgents.url + `/${newNumber}/extention/pdf`,
      {
        responseType: "arraybuffer",
      },
    );
    const buffer = res.data;
    const blob = new Blob([buffer], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    window.open(url, "_blank");
    setdownloadFormAgent(false);
  }

  async function approveExpire() {
    const ExpiredAgentExtFiles = file.filter(isExpiredLicenseFile);
    const IdCardExtFiles = file.filter((x) => x.FileType === "IdCardExtFiles");
    const JuristicPersonExtFiles = file.filter(
      (x) => x.FileType === "JuristicPersonExtFiles",
    );
    const StoreMapExtFiles = file.filter(
      (x) => x.FileType === "StoreMapExtFiles",
    );
    const LicenseExtFiles = file.filter(
      (x) => x.FileType === "LicenseExtFiles",
    );
    if (
      file.length === 0 ||
      (AutoExpiredAgentExtFile ? false : ExpiredAgentExtFiles.length === 0) ||
      IdCardExtFiles.length === 0 ||
      JuristicPersonExtFiles.length === 0 ||
      StoreMapExtFiles.length === 0 ||
      LicenseExtFiles.length === 0
    ) {
      Swal.fire(
        "กรุณาอัพโหลดเอกสารที่จำเป็นในการต่ออายุให้ครบถ้วน",
        "",
        "question",
      );
    } else {
      if (contactName.length === 0) {
        setContactNameError(true);
      }
      if (customerFName.length === 0) {
        setCustomerFNameError(true);
      }
      if (customerLName.length === 0) {
        setCustomerLNameError(true);
      }
      if (Nationality.length === 0) {
        setNationalityError(true);
      }
      if (nationalityId.length === 0) {
        setNationalityIdError(true);
        setNationalityIdErrorText("กรุณากรอกบัตรประจำตัวประชาชน");
      }
      if (juristicPersonId?.length === 0 && personType === "นิติบุคคล") {
        setJuristicPersonIdError(true);
        setJuristicPersonIdErrorText("กรุณากรอกเลขที่นิติบุคคล");
      }
      if (juristicPersonId?.length === 0 && personType !== "นิติบุคคล") {
        setJuristicPersonIdError(true);
        setJuristicPersonIdErrorText("กรุณากรอกทะเบียนพาณิชย์");
      }
      if (tel.length === 0) {
        setTelError(true);
      }
      if (email.length === 0) {
        setEmailError(true);
      }
      if (!BirthDate) {
        setBirthDateError(true);
      }
      if (province.length === 0) {
        setProvinceError(true);
      }
      if (district.length === 0) {
        setDistrictError(true);
      }
      if (subDistrict.length === 0) {
        setSubDistrictError(true);
      }
      if (zipcode.length === 0) {
        setZipcodeError(true);
      }
      if (ShopProvince.length === 0) {
        setShopProvinceError(true);
      }
      if (ShopDistrict.length === 0) {
        setShopDistrictError(true);
      }
      if (ShopSubDistrict.length === 0) {
        setShopSubDistrictError(true);
      }
      if (ShopZipcode.length === 0) {
        setShopZipcodeError(true);
      }
      if (
        contactName.length > 0 &&
        customerFName.length > 0 &&
        customerLName.length > 0 &&
        Nationality.length > 0 &&
        nationalityId.length > 0 &&
        (personType === "นิติบุคคล" ? juristicPersonId.length > 0 : true) &&
        tel.length > 0 &&
        email.length > 0 &&
        BirthDate &&
        province.length > 0 &&
        district.length > 0 &&
        subDistrict.length > 0 &&
        zipcode.length > 0 &&
        ShopProvince.length > 0 &&
        ShopDistrict.length > 0 &&
        ShopSubDistrict.length > 0 &&
        ShopZipcode.length > 0
      ) {
        Swal.fire({
          title: "ยืนยันอนุมัติการต่ออายุ",
          icon: "question",
          showCancelButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            EditWhenApprove();
          }
        });
      }
    }
  }

  const onBlur = (e) => {
    if (!e.target.value) {
      setBirthDateError(true);
    } else {
      setBirthDateError(false);
    }
  };

  return (
    <div style={{ padding: "10px 30px" }}>
      <Page>
        <form>
          <div class="card-content mt-4">
            <div class="container-fluid">
              <div class="d-flex row align-items-center ">
                <div class="col-8 d-flex">
                  <label class="title-content mb-4 me-4">
                    {mode
                      ? "ข้อมูลต่ออายุตัวแทนจำหน่าย"
                      : "ข้อมูลตัวแทนจำหน่าย"}
                  </label>
                  {!id && (
                    <Autocomplete
                      options={customers || []}
                      componentsProps={{
                        paper: {
                          sx: {
                            width: 500,
                          },
                        },
                      }}
                      getOptionLabel={(option) => option?.ContactName}
                      renderOption={(props, option) => (
                        <Box component="li" {...props} key={option.CustomerNo}>
                          ( {option?.CustomerNo} ) {option?.ContactName}
                        </Box>
                      )}
                      inputValue={customerName || ""}
                      onInputChange={(event, newInputValue) => {
                        setCustomerName(newInputValue);
                      }}
                      value={null}
                      onChange={(event, newValue) => {
                        setCustomerData(newValue);
                      }}
                      renderInput={(params) => (
                        <Box
                          className="backgroundField"
                          sx={{ marginBottom: "10px" }}
                          ref={params.InputProps.ref}
                        >
                          <FontAwesomeIcon
                            icon={faSearch}
                            style={{ color: "#7e7e7e", marginRight: "10px" }}
                          />
                          <Input
                            placeholder="ค้นหาลูกค้า"
                            type="text"
                            {...params.inputProps}
                            disableUnderline
                          />
                        </Box>
                      )}
                    />
                  )}
                </div>
                {id && (
                  <div class="col-4 text-end px-4">
                    <Button
                      disabled={downloadFormAgent}
                      type="button"
                      onClick={handleClick}
                      className="ButtomSearch"
                      variant="contained"
                      sx={{
                        width: "110px",
                        background: "#3364af57 0 0 no-repeat padding-box",
                        border: "1px solid #3364af57",
                        color: "#3364af",
                        fontWeight: "700",
                        borderRadius: "100px",
                        ":hover": {
                          background: "#3364af57 0 0 no-repeat padding-box",
                        },
                      }}
                    >
                      {downloadFormAgent ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "พิมพ์"
                      )}
                    </Button>

                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                      PaperProps={{
                        style: {
                          width: 220,
                        },
                      }}
                    >
                      <MenuItem onClick={() => downLoadRegister()}>
                        ตจ.1
                      </MenuItem>

                      {detail?.Status === "Y" && (
                        <>
                          {mode && (
                            <MenuItem onClick={() => downloadExtensionExpire()}>
                              ตจ.2
                            </MenuItem>
                          )}
                          <MenuItem onClick={() => openDialogSigner(null)}>
                            ตจ.4 (ผู้อำนวยการ)
                          </MenuItem>
                          <MenuItem
                            onClick={() => openDialogSigner("รักษาการแทน")}
                          >
                            ตจ.4 (รักษาการแทน)
                          </MenuItem>
                          <MenuItem
                            onClick={() =>
                              openDialogSigner("รักษาการในตำแหน่ง")
                            }
                          >
                            ตจ.4 (รักษาการในตำแหน่ง)
                          </MenuItem>
                          <MenuItem
                            onClick={() => openDialogSigner("ทำหน้าที่")}
                          >
                            ตจ.4 (ทำหน้าที่ผู้อำนวยการ)
                          </MenuItem>
                        </>
                      )}
                    </Menu>
                  </div>
                )}
              </div>

              {id && (
                <div class="row">
                  <div class="col-lg-4 col-md-6">
                    <label class="labelInput me-3">ผู้สร้าง</label>{" "}
                    <label class="message-error-label">
                      ( {dayjs(detail?.CreateDate).format("DD/MM/BBBB")} )
                    </label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                    >
                      <TextField
                        disabled
                        value={detail?.CreateId}
                        variant="standard"
                        fullWidth
                        InputProps={{
                          disableUnderline: true,
                        }}
                      />
                    </Box>
                  </div>
                  <div class="col-lg-4 col-md-6">
                    <label class="labelInput me-3">ผู้แก้ไข</label>{" "}
                    <label class="message-error-label">
                      ( {dayjs(detail?.ModifiedDate).format("DD/MM/BBBB")} )
                    </label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                    >
                      <TextField
                        disabled
                        value={detail?.ModifiedId}
                        variant="standard"
                        fullWidth
                        InputProps={{
                          disableUnderline: true,
                        }}
                      />
                    </Box>
                  </div>
                </div>
              )}
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">เลขที่ตัวแทนจำหน่าย</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      disabled={profile?.BranchNo?.BranchNo !== "00"}
                      value={agentNumber}
                      onChange={(e) => setAgentNumber(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9-/]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Box>
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <FormControl variant="standard" fullWidth>
                      <Select
                        value={BranchNo || ""}
                        onChange={(e) => setBranchsNo(e.target.value)}
                        disableUnderline
                      >
                        {branchs?.map((x) => (
                          <MenuItem value={x?.BranchNo}>
                            {x?.BranchName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">เลขที่เอกสาร</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      disabled={profile?.BranchNo?.BranchNo !== "00"}
                      value={refNo}
                      onChange={(e) => setRefNo(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9-/]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Box>
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">วันที่อนุมัติ</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <MobileDatePicker
                      dayOfWeekFormatter={(day) => `${day}`}
                      value={approveDate}
                      onChange={(e) => setApproveDate(e)}
                      slotProps={{
                        textField: {
                          variant: "standard",
                          fullWidth: true,
                          InputProps: { disableUnderline: true },
                          value: approveDate,
                        },
                      }}
                      slots={{
                        textField: BrowserInput,
                      }}
                    />
                  </Box>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-8 col-md-12">
                  <label class="labelInput">ประเภทบุคคล</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <FormControl variant="standard" fullWidth>
                      <Select
                        value={personType || ""}
                        onChange={(e) => {
                          setJuristicPersonIdError(false);
                          setJuristicPersonIdErrorText("");
                          setJuristicPersonId("");
                          setJuristicPersonType("");
                          // setcommercial_registration('')
                          setPersonType(e.target.value);
                        }}
                        disableUnderline
                      >
                        <MenuItem value="บุคคลธรรมดา">บุคคลธรรมดา</MenuItem>
                        <MenuItem value="นิติบุคคล">นิติบุคคล</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </div>
              </div>

              <div class="row">
                {personType === "บุคคลธรรมดา" ? (
                  <div class="col-lg-8 col-md-12">
                    <label class="labelInput">ทะเบียนพาณิชย์</label>
                    <Box
                      className={`backgroundField ${juristicPersonIdError ? "error" : ""}`}
                    >
                      <TextField
                        value={juristicPersonId}
                        onChange={(e) => {
                          setJuristicPersonId(e.target.value);
                        }}
                        variant="standard"
                        fullWidth
                        onBlur={(e) => {
                          if (!e.target.value && personType !== "นิติบุคคล") {
                            setJuristicPersonIdError(true);
                            setJuristicPersonIdErrorText(
                              "กรุณากรอกทะเบียนพาณิชย์",
                            );
                          } else {
                            setJuristicPersonIdError(false);
                            setJuristicPersonIdErrorText("");
                          }
                        }}
                        InputProps={{
                          disableUnderline: true,
                        }}
                      />
                    </Box>
                    {juristicPersonIdError ? (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {juristicPersonIdErrorText}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  <>
                    <div class="col-lg-4 col-md-12">
                      <label class="labelInput">ประเภทนิติบุคคล</label>
                      <Box
                        className="backgroundField"
                        sx={{ marginBottom: "10px" }}
                      >
                        <TextField
                          value={juristicPersonType || ""}
                          onChange={(e) =>
                            setJuristicPersonType(e.target.value)
                          }
                          variant="standard"
                          fullWidth
                          InputProps={{
                            disableUnderline: true,
                          }}
                        />
                      </Box>
                    </div>
                    <div class="col-lg-4 col-md-12">
                      <label class="labelInput">นิติบุคคลเลขที่</label>
                      <Box
                        className={`backgroundField ${juristicPersonIdError ? "error" : ""}`}
                      >
                        <TextField
                          value={juristicPersonId}
                          onChange={(e) => {
                            if (e.target.value.length < 13) {
                              setJuristicPersonId(e.target.value);
                            } else {
                              setJuristicPersonIdError(false);
                              setJuristicPersonId(e.target.value);
                              setJuristicPersonIdCheck(true);
                              getJuristic(e.target.value);
                            }
                          }}
                          variant="standard"
                          fullWidth
                          onBlur={(e) => {
                            if (!e.target.value && personType === "นิติบุคคล") {
                              setJuristicPersonIdError(true);
                              setJuristicPersonIdErrorText(
                                "กรุณากรอกเลขที่นิติบุคคล",
                              );
                              setJuristicPersonIdCheck(false);
                            } else {
                              if (
                                e.target.value.length < 13 &&
                                personType === "นิติบุคคล"
                              ) {
                                setJuristicPersonIdError(true);
                                setJuristicPersonIdErrorText(
                                  "กรุณากรอกให้ครบ 13 หลัก",
                                );
                                setJuristicPersonIdCheck(false);
                              } else {
                                setJuristicPersonIdError(false);
                                if (e.target.value.length > 1) {
                                  setJuristicPersonIdCheck(true);
                                }
                              }
                            }
                          }}
                          InputProps={{
                            disableUnderline: true,
                          }}
                          inputProps={{ maxLength: 13 }}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        {juristicPersonIdCheck && (
                          <div
                            style={{
                              color: juristicPersonIdApiCheck
                                ? "#fff"
                                : "#f1f1f1",
                              fontSize: "18px",
                              background: juristicPersonIdApiCheck
                                ? "green"
                                : "#bbbbbb",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "32px",
                              height: "32px",
                              borderRadius: "50%",
                            }}
                          >
                            <FontAwesomeIcon icon={faCheck} />
                          </div>
                        )}
                      </Box>
                      {juristicPersonIdError ? (
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {juristicPersonIdErrorText}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                )}
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">ผู้มีอำนาจลงนามแทน</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={authorizedSignatory}
                      onChange={(e) => setAuthorizedSignatory(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>

                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">วันที่จดทะเบียน</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <MobileDatePicker
                      dayOfWeekFormatter={(day) => `${day}`}
                      value={issuerDate}
                      onChange={(e) => setIssuerDate(e)}
                      slotProps={{
                        textField: {
                          variant: "standard",
                          fullWidth: true,
                          InputProps: { disableUnderline: true },
                          value: issuerDate,
                        },
                      }}
                      slots={{
                        textField: BrowserInput,
                      }}
                    />
                  </Box>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-8 col-md-12">
                  <label class="labelInput">ชื่อร้านค้า</label>
                  <RequireField
                    value={contactName}
                    onChange={setContactName}
                    type={"text"}
                    error={contactNameError}
                    setError={setContactNameError}
                    textError={"กรุณากรอกชื่อร้านค้า"}
                  />
                </div>
              </div>

              <div class="row" style={{ alignItems: "flex-end" }}>
                {gender === "อื่นๆ" && (
                  <div class="col-lg-2 col-md-12">
                    <label class="labelInput">คำหน้าอื่นๆ</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                    >
                      <TextField
                        value={textGender}
                        onChange={(e) => setTextGender(e.target.value)}
                        variant="standard"
                        fullWidth
                        InputProps={{
                          disableUnderline: true,
                        }}
                      />
                    </Box>
                  </div>
                )}
                <div
                  class={
                    gender === "อื่นๆ"
                      ? "col-lg-3 col-md-12"
                      : "col-lg-4 col-md-12"
                  }
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <label class="labelInput me-4">ชื่อ </label>
                    <FormControl>
                      <RadioGroup
                        row
                        value={gender}
                        onChange={(e) => {
                          setGender(e.target.value);
                          if (e.target.value === "อื่นๆ") {
                            setTextGender("นาย");
                          } else {
                            setTextGender(e.target.value);
                          }
                        }}
                      >
                        <FormControlLabel
                          value="นาย"
                          control={<Radio size="small" />}
                          label="นาย"
                        />
                        <FormControlLabel
                          value="นาง"
                          control={<Radio size="small" />}
                          label="นาง"
                        />
                        <FormControlLabel
                          value="นางสาว"
                          control={<Radio size="small" />}
                          label="นางสาว"
                        />
                        <FormControlLabel
                          value="อื่นๆ"
                          control={<Radio size="small" />}
                          label="อื่นๆ"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  <RequireField
                    value={customerFName}
                    onChange={setCustomerFName}
                    type={"text"}
                    error={customerFNameError}
                    setError={setCustomerFNameError}
                    textError={"กรุณากรอกชื่อ"}
                  />
                </div>
                <div
                  class={
                    gender === "อื่นๆ"
                      ? "col-lg-3 col-md-12"
                      : "col-lg-4 col-md-12"
                  }
                >
                  <label class="labelInput">นามสกุล</label>
                  <RequireField
                    value={customerLName}
                    onChange={setCustomerLName}
                    type={"text"}
                    error={customerLNameError}
                    setError={setCustomerLNameError}
                    textError={"กรุณากรอกนามสกุล"}
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">บัตรประจำตัวประชาชน</label>

                  <Box
                    className={`backgroundField ${nationalityIdError ? "error" : ""}`}
                  >
                    <TextField
                      value={nationalityId}
                      onChange={(e) => {
                        if (e.target.value.length < 13) {
                          setNationalityId(e.target.value);
                        } else {
                          if (Script_checkID(e.target.value)) {
                            setNationalityIdError(false);
                            setNationalityId(e.target.value);
                            setNationalityIdCheck(true);
                            getNationality(e.target.value);
                          } else {
                            setNationalityIdError(true);
                            setNationalityIdErrorText(
                              "บัตรประจำตัวประชาชนไม่ถูกต้อง",
                            );
                            setNationalityId(e.target.value);
                            setNationalityIdCheck(false);
                          }
                        }
                      }}
                      variant="standard"
                      fullWidth
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setNationalityIdError(true);
                          setNationalityIdErrorText(
                            "กรุณากรอกบัตรประจำตัวประชาชน",
                          );
                          setNationalityIdCheck(false);
                        } else {
                          if (e.target.value.length < 13) {
                            setNationalityIdError(true);
                            setNationalityIdErrorText(
                              "กรุณากรอกให้ครบ 13 หลัก",
                            );
                            setNationalityIdCheck(false);
                          } else {
                            if (Script_checkID(e.target.value)) {
                              setNationalityIdError(false);
                            } else {
                              setNationalityIdError(true);
                              setNationalityIdErrorText(
                                "บัตรประจำตัวประชาชนไม่ถูกต้อง",
                              );
                              setNationalityIdCheck(false);
                            }
                          }
                        }
                      }}
                      InputProps={{
                        disableUnderline: true,
                      }}
                      inputProps={{ maxLength: 13 }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                    {nationalityIdCheck && (
                      <div
                        style={{
                          color: nationalityIdApiCheck ? "#fff" : "#f1f1f1",
                          fontSize: "18px",
                          background: nationalityIdApiCheck
                            ? "green"
                            : "#bbbbbb",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "32px",
                          height: "32px",
                          borderRadius: "50%",
                        }}
                      >
                        <FontAwesomeIcon icon={faCheck} />
                      </div>
                    )}
                  </Box>
                  {nationalityIdError && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {nationalityIdErrorText}
                    </span>
                  )}
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">อีเมล</label>
                  <RequireField
                    value={email}
                    onChange={setEmail}
                    type={"text"}
                    error={emailError}
                    setError={setEmailError}
                    textError={"กรุณากรอกอีเมล"}
                    onKeyPress={(event) => {
                      if (!/[a-zA-Z0-9@._-]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">ออกให้ ณ อำเภอ/เขต</label>
                  <Autocomplete
                    fullWidth
                    options={locationsI || []}
                    getOptionLabel={(option) => option?.DistrictName}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.SubDistrictId}>
                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                        {option?.SubDistrictName} / {option?.Zipcode}
                      </Box>
                    )}
                    loading={locationsI.length > 0}
                    inputValue={IssuerDistrict || ""}
                    onInputChange={(event, newInputValue) => {
                      setIssuerDistrict(newInputValue);
                    }}
                    noOptionsText="loading..."
                    value={valueI || null}
                    onChange={(event, newValue) => {
                      setValueI(newValue);
                      // setValueD(newValue)
                    }}
                    renderInput={(params) => (
                      <Box
                        className="backgroundField"
                        sx={{ marginBottom: "10px" }}
                        ref={params.InputProps.ref}
                      >
                        <Input
                          type="text"
                          {...params.inputProps}
                          disableUnderline
                        />
                      </Box>
                    )}
                  />
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">จังหวัด</label>
                  <Autocomplete
                    fullWidth
                    options={locationsI || []}
                    getOptionLabel={(option) => option?.ProvinceName}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.SubDistrictId}>
                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                        {option?.SubDistrictName} / {option?.Zipcode}
                      </Box>
                    )}
                    inputValue={IssuerProvince || ""}
                    onInputChange={(event, newInputValue) => {
                      setIssuerProvince(newInputValue);
                    }}
                    loading={locationsI.length > 0}
                    value={valueI || null}
                    onChange={(event, newValue) => {
                      setValueI(newValue);
                      // setValueD(newValue)
                    }}
                    renderInput={(params) => (
                      <Box
                        className="backgroundField"
                        sx={{ marginBottom: "10px" }}
                        ref={params.InputProps.ref}
                      >
                        <Input
                          type="text"
                          {...params.inputProps}
                          disableUnderline
                        />
                      </Box>
                    )}
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">โทรศัพท์</label>
                  <RequireField
                    value={tel}
                    onChange={setTel}
                    type={"number"}
                    error={telError}
                    setError={setTelError}
                    textError={"กรุณากรอกเบอร์โทรศัพท์"}
                  />
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">โทรสาร</label>

                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={fax}
                      onChange={(e) => setFax(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Box>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">วันเกิด</label>
                  <Box
                    className={`backgroundField ${BirthDateError ? "error" : ""}`}
                  >
                    <MobileDatePicker
                      dayOfWeekFormatter={(day) => `${day}`}
                      value={BirthDate}
                      onChange={(e) => setBirthDate(e)}
                      slotProps={{
                        textField: {
                          variant: "standard",
                          fullWidth: true,
                          InputProps: { disableUnderline: true },
                          value: BirthDate,
                          onBlur: onBlur,
                        },
                      }}
                      slots={{
                        textField: BrowserInput,
                      }}
                    />
                  </Box>
                  {BirthDateError && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      กรุณาเลือกวันเกิด
                    </span>
                  )}
                </div>
                <div class="col-lg-2 col-md-12">
                  <label class="labelInput">อายุ</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      disabled
                      value={dayjs(new Date()).year() - dayjs(BirthDate).year()}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>

                <div class="col-lg-2 col-md-12">
                  <label class="labelInput">สัญชาติ</label>
                  <Box
                    className={`backgroundField ${NationalityError ? "error" : ""}`}
                  >
                    <TextField
                      value={Nationality}
                      onChange={(e) => setNationality(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setNationalityError(true);
                        } else {
                          setNationalityError(false);
                        }
                      }}
                    />
                  </Box>
                </div>
              </div>

              <hr class="chr" />

              <div class="d-flex row align-items-center ">
                <div class="col-6">
                  <label class="title-content mb-4">
                    ที่อยู่ตามบัตรประชาชน
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">บ้านเลขที่</label>

                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={houseNumber}
                      onChange={(e) => setHouseNumber(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">หมู่</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={moo}
                      onChange={(e) => setMoo(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Box>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">ตรอก/ซอย</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={alley}
                      onChange={(e) => setAlley(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">ถนน</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">ตำบล</label>
                  <Autocomplete
                    fullWidth
                    options={locations || []}
                    getOptionLabel={(option) => option?.SubDistrictName}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.SubDistrictId}>
                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                        {option?.SubDistrictName} / {option?.Zipcode}
                      </Box>
                    )}
                    loading={locations.length > 0}
                    inputValue={subDistrict || ""}
                    onInputChange={(event, newInputValue) => {
                      setSubDistrict(newInputValue);
                    }}
                    value={value || null}
                    onChange={(event, newValue) => {
                      setValue(newValue);
                      // setValueD(newValue)
                    }}
                    onBlur={(e) => {
                      if (!e.target.value) {
                        setSubDistrictError(true);
                      } else {
                        setSubDistrictError(false);
                      }
                    }}
                    renderInput={(params) => (
                      <Box
                        className={`backgroundField ${subDistrict.length === 0 && subDistrictError ? "error" : ""}`}
                        ref={params.InputProps.ref}
                      >
                        <Input
                          type="text"
                          {...params.inputProps}
                          disableUnderline
                        />
                      </Box>
                    )}
                  />
                  {subDistrict.length === 0 && subDistrictError && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      กรุณากรอกตำบล
                    </span>
                  )}
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">อำเภอ</label>
                  <Autocomplete
                    fullWidth
                    options={locations || []}
                    getOptionLabel={(option) => option?.DistrictName}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.SubDistrictId}>
                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                        {option?.SubDistrictName} / {option?.Zipcode}
                      </Box>
                    )}
                    loading={locations.length > 0}
                    inputValue={district || ""}
                    onInputChange={(event, newInputValue) => {
                      setDistrict(newInputValue);
                    }}
                    value={value || null}
                    onChange={(event, newValue) => {
                      setValue(newValue);
                      // setValueD(newValue)
                    }}
                    onBlur={(e) => {
                      if (!e.target.value) {
                        setDistrictError(true);
                      } else {
                        setDistrictError(false);
                      }
                    }}
                    renderInput={(params) => (
                      <Box
                        className={`backgroundField ${district.length === 0 && districtError ? "error" : ""}`}
                        ref={params.InputProps.ref}
                      >
                        <Input
                          type="text"
                          {...params.inputProps}
                          disableUnderline
                        />
                      </Box>
                    )}
                  />
                  {district.length === 0 && districtError && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      กรุณากรอกอำเภอ
                    </span>
                  )}
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">จังหวัด</label>
                  <Autocomplete
                    fullWidth
                    options={locations || []}
                    getOptionLabel={(option) => option?.ProvinceName}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.SubDistrictId}>
                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                        {option?.SubDistrictName} / {option?.Zipcode}
                      </Box>
                    )}
                    loading={locations.length > 0}
                    inputValue={province || ""}
                    onInputChange={(event, newInputValue) => {
                      setProvince(newInputValue);
                    }}
                    value={value || null}
                    onChange={(event, newValue) => {
                      setValue(newValue);
                      // setValueD(newValue)
                    }}
                    onBlur={(e) => {
                      if (!e.target.value) {
                        setProvinceError(true);
                      } else {
                        setProvinceError(false);
                      }
                    }}
                    renderInput={(params) => (
                      <Box
                        className={`backgroundField ${province.length === 0 && provinceError ? "error" : ""}`}
                        ref={params.InputProps.ref}
                      >
                        <Input
                          type="text"
                          {...params.inputProps}
                          disableUnderline
                        />
                      </Box>
                    )}
                  />
                  {province.length === 0 && provinceError && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      กรุณากรอกจังหวัด
                    </span>
                  )}
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">รหัสไปรษณีย์</label>
                  <Autocomplete
                    fullWidth
                    options={locations || []}
                    getOptionLabel={(option) => option?.Zipcode}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.SubDistrictId}>
                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                        {option?.SubDistrictName} / {option?.Zipcode}
                      </Box>
                    )}
                    loading={locations.length > 0}
                    inputValue={zipcode || ""}
                    onInputChange={(event, newInputValue) => {
                      setZipcode(newInputValue);
                    }}
                    value={value || null}
                    onChange={(event, newValue) => {
                      setValue(newValue);
                      // setValueD(newValue)
                    }}
                    onBlur={(e) => {
                      if (!e.target.value) {
                        setZipcodeError(true);
                      } else {
                        setZipcodeError(false);
                      }
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    renderInput={(params) => (
                      <Box
                        className={`backgroundField ${zipcode.length === 0 && zipcodeError ? "error" : ""}`}
                        ref={params.InputProps.ref}
                      >
                        <Input
                          type="text"
                          {...params.inputProps}
                          disableUnderline
                        />
                      </Box>
                    )}
                  />
                  {zipcode.length === 0 && zipcodeError && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      กรุณากรอกรหัสไปรษณีย์
                    </span>
                  )}
                </div>
              </div>

              <hr class="chr" />

              <div class="d-flex row align-items-center">
                <div class="col-6">
                  <label class="title-content mb-4 me-5">สถานที่จำหน่าย</label>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={(e) => {
                          if (e.target.checked === true) {
                            setValueS(value);
                            setShopHouseNumber(houseNumber);
                            setShopMoo(moo);
                            setShopAlley(alley);
                            setShopAddress(address);
                          } else {
                            setValueS();
                            setShopHouseNumber("");
                            setShopMoo("");
                            setShopAlley("");
                            setShopAddress("");
                          }
                        }}
                      />
                    }
                    label="ที่อยู่ตามบัตรประชาชน"
                  />
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">โทรศัพท์</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={ShopTel}
                      onChange={(e) => setShopTel(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Box>
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">โทรสาร</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={ShopFax}
                      onChange={(e) => setShopFax(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Box>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">บ้านเลขที่</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={ShopHouseNumber}
                      onChange={(e) => setShopHouseNumber(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">หมู่</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={ShopMoo}
                      onChange={(e) => setShopMoo(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Box>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">ตรอก/ซอย</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={ShopAlley}
                      onChange={(e) => setShopAlley(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">ถนน</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={ShopAddress}
                      onChange={(e) => setShopAddress(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">ตำบล</label>
                  <Autocomplete
                    fullWidth
                    options={locationsS || []}
                    getOptionLabel={(option) => option?.SubDistrictName}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.SubDistrictId}>
                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                        {option?.SubDistrictName} / {option?.Zipcode}
                      </Box>
                    )}
                    loading={locationsS.length > 0}
                    inputValue={ShopSubDistrict || ""}
                    onInputChange={(event, newInputValue) => {
                      setShopSubDistrict(newInputValue);
                    }}
                    value={valueS || null}
                    onChange={(event, newValue) => {
                      setValueS(newValue);
                      // setValueD(newValue)
                    }}
                    onBlur={(e) => {
                      if (!e.target.value) {
                        setShopSubDistrictError(true);
                      } else {
                        setShopSubDistrictError(false);
                      }
                    }}
                    renderInput={(params) => (
                      <Box
                        className={`backgroundField ${ShopSubDistrict.length === 0 && ShopSubDistrictError ? "error" : ""}`}
                        ref={params.InputProps.ref}
                      >
                        <Input
                          type="text"
                          {...params.inputProps}
                          disableUnderline
                        />
                      </Box>
                    )}
                  />
                  {ShopSubDistrict.length === 0 && ShopSubDistrictError && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      กรุณากรอกตำบล
                    </span>
                  )}
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">อำเภอ</label>
                  <Autocomplete
                    fullWidth
                    options={locationsS || []}
                    getOptionLabel={(option) => option?.DistrictName}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.SubDistrictId}>
                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                        {option?.SubDistrictName} / {option?.Zipcode}
                      </Box>
                    )}
                    loading={locationsS.length > 0}
                    inputValue={ShopDistrict || ""}
                    onInputChange={(event, newInputValue) => {
                      setShopDistrict(newInputValue);
                    }}
                    value={valueS || null}
                    onChange={(event, newValue) => {
                      setValueS(newValue);
                      // setValueD(newValue)
                    }}
                    onBlur={(e) => {
                      if (!e.target.value) {
                        setShopDistrictError(true);
                      } else {
                        setShopDistrictError(false);
                      }
                    }}
                    renderInput={(params) => (
                      <Box
                        className={`backgroundField ${ShopDistrict.length === 0 && ShopDistrictError ? "error" : ""}`}
                        ref={params.InputProps.ref}
                      >
                        <Input
                          type="text"
                          {...params.inputProps}
                          disableUnderline
                        />
                      </Box>
                    )}
                  />
                  {ShopDistrict.length === 0 && ShopDistrictError && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      กรุณากรอกอำเภอ
                    </span>
                  )}
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">จังหวัด</label>
                  <Autocomplete
                    fullWidth
                    options={locationsS || []}
                    getOptionLabel={(option) => option?.ProvinceName}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.SubDistrictId}>
                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                        {option?.SubDistrictName} / {option?.Zipcode}
                      </Box>
                    )}
                    loading={locationsS.length > 0}
                    inputValue={ShopProvince || ""}
                    onInputChange={(event, newInputValue) => {
                      setShopProvince(newInputValue);
                    }}
                    value={valueS || null}
                    onChange={(event, newValue) => {
                      setValueS(newValue);
                      // setValueD(newValue)
                    }}
                    onBlur={(e) => {
                      if (!e.target.value) {
                        setShopProvinceError(true);
                      } else {
                        setShopProvinceError(false);
                      }
                    }}
                    renderInput={(params) => (
                      <Box
                        className={`backgroundField ${ShopProvince.length === 0 && ShopProvinceError ? "error" : ""}`}
                        ref={params.InputProps.ref}
                      >
                        <Input
                          type="text"
                          {...params.inputProps}
                          disableUnderline
                        />
                      </Box>
                    )}
                  />
                  {ShopProvince.length === 0 && ShopProvinceError && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      กรุณากรอกจังหวัด
                    </span>
                  )}
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">รหัสไปรษณีย์</label>
                  <Autocomplete
                    fullWidth
                    options={locationsS || []}
                    getOptionLabel={(option) => option?.Zipcode}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.SubDistrictId}>
                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                        {option?.SubDistrictName} / {option?.Zipcode}
                      </Box>
                    )}
                    loading={locationsS.length > 0}
                    inputValue={ShopZipcode || ""}
                    onInputChange={(event, newInputValue) => {
                      setShopZipcode(newInputValue);
                    }}
                    value={valueS || null}
                    onChange={(event, newValue) => {
                      setValueS(newValue);
                      // setValueD(newValue)
                    }}
                    onBlur={(e) => {
                      if (!e.target.value) {
                        setShopZipcodeError(true);
                      } else {
                        setShopZipcodeError(false);
                      }
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    renderInput={(params) => (
                      <Box
                        className={`backgroundField ${ShopZipcode.length === 0 && ShopZipcodeError ? "error" : ""}`}
                        sx={{ marginBottom: "10px" }}
                        ref={params.InputProps.ref}
                      >
                        <Input
                          type="text"
                          {...params.inputProps}
                          disableUnderline
                        />
                      </Box>
                    )}
                  />
                  {ShopZipcode.length === 0 && ShopZipcodeError && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      กรุณากรอกรหัสไปรษณีย์
                    </span>
                  )}
                </div>
              </div>
              <hr class="chr" />

              <div class="d-flex row align-items-center">
                <div class="col-6">
                  <label class="title-content mb-4 me-5">ที่อยู่สำนักงาน</label>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={(e) => {
                          if (e.target.checked === true) {
                            setValueO(value);
                            setOfficeHouseNumber(houseNumber);
                            setOfficeMoo(moo);
                            setOfficeAlley(alley);
                            setOfficeAddress(address);
                          } else {
                            setValueO();
                            setOfficeHouseNumber("");
                            setOfficeMoo("");
                            setOfficeAlley("");
                            setOfficeAddress("");
                          }
                        }}
                      />
                    }
                    label="ที่อยู่ตามบัตรประชาชน"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={(e) => {
                          if (e.target.checked === true) {
                            setValueO(valueS);
                            setOfficeHouseNumber(ShopHouseNumber);
                            setOfficeMoo(ShopMoo);
                            setOfficeAlley(ShopAlley);
                            setOfficeAddress(ShopAddress);
                            setOfficeFax(ShopFax);
                            setOfficeTel(ShopTel);
                          } else {
                            setValueO();
                            setOfficeHouseNumber("");
                            setOfficeMoo("");
                            setOfficeAlley("");
                            setOfficeAddress("");
                            setOfficeFax("");
                            setOfficeTel("");
                          }
                        }}
                      />
                    }
                    label="ที่อยู่ตามสถานที่จำหน่าย"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">โทรศัพท์</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={OfficeTel}
                      onChange={(e) => setOfficeTel(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Box>
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">โทรสาร</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={OfficeFax}
                      onChange={(e) => setOfficeFax(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Box>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">บ้านเลขที่</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={OfficeHouseNumber}
                      onChange={(e) => setOfficeHouseNumber(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">หมู่</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={OfficeMoo}
                      onChange={(e) => setOfficeMoo(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </Box>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">ตรอก/ซอย</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={OfficeAlley}
                      onChange={(e) => setOfficeAlley(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">ถนน</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={OfficeAddress}
                      onChange={(e) => setOfficeAddress(e.target.value)}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                      }}
                    />
                  </Box>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">ตำบล</label>
                  <Autocomplete
                    fullWidth
                    options={locationsO || []}
                    getOptionLabel={(option) => option?.SubDistrictName}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.SubDistrictId}>
                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                        {option?.SubDistrictName} / {option?.Zipcode}
                      </Box>
                    )}
                    loading={locationsO.length > 0}
                    inputValue={OfficeSubDistrict || ""}
                    onInputChange={(event, newInputValue) => {
                      setOfficeSubDistrict(newInputValue);
                    }}
                    value={valueO || null}
                    onChange={(event, newValue) => {
                      setValueO(newValue);
                      // setValueD(newValue)
                    }}
                    renderInput={(params) => (
                      <Box
                        className="backgroundField"
                        sx={{ marginBottom: "10px" }}
                        ref={params.InputProps.ref}
                      >
                        <Input
                          type="text"
                          {...params.inputProps}
                          disableUnderline
                        />
                      </Box>
                    )}
                  />
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">อำเภอ</label>
                  <Autocomplete
                    fullWidth
                    options={locationsO || []}
                    getOptionLabel={(option) => option?.DistrictName}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.SubDistrictId}>
                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                        {option?.SubDistrictName} / {option?.Zipcode}
                      </Box>
                    )}
                    loading={locationsO.length > 0}
                    inputValue={OfficeDistrict || ""}
                    onInputChange={(event, newInputValue) => {
                      setOfficeDistrict(newInputValue);
                    }}
                    value={valueO || null}
                    onChange={(event, newValue) => {
                      setValueO(newValue);
                      // setValueD(newValue)
                    }}
                    renderInput={(params) => (
                      <Box
                        className="backgroundField"
                        sx={{ marginBottom: "10px" }}
                        ref={params.InputProps.ref}
                      >
                        <Input
                          type="text"
                          {...params.inputProps}
                          disableUnderline
                        />
                      </Box>
                    )}
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">จังหวัด</label>
                  <Autocomplete
                    fullWidth
                    options={locationsO || []}
                    getOptionLabel={(option) => option?.ProvinceName}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.SubDistrictId}>
                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                        {option?.SubDistrictName} / {option?.Zipcode}
                      </Box>
                    )}
                    loading={locationsO.length > 0}
                    inputValue={OfficeProvince || ""}
                    onInputChange={(event, newInputValue) => {
                      setOfficeProvince(newInputValue);
                    }}
                    value={valueO || null}
                    onChange={(event, newValue) => {
                      setValueO(newValue);
                      // setValueD(newValue)
                    }}
                    renderInput={(params) => (
                      <Box
                        className="backgroundField"
                        sx={{ marginBottom: "10px" }}
                        ref={params.InputProps.ref}
                      >
                        <Input
                          type="text"
                          {...params.inputProps}
                          disableUnderline
                        />
                      </Box>
                    )}
                  />
                </div>
                <div class="col-lg-4 col-md-12">
                  <label class="labelInput">รหัสไปรษณีย์</label>
                  <Autocomplete
                    fullWidth
                    options={locationsO || []}
                    getOptionLabel={(option) => option?.Zipcode}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.SubDistrictId}>
                        จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                        {option?.SubDistrictName} / {option?.Zipcode}
                      </Box>
                    )}
                    loading={locationsO.length > 0}
                    inputValue={OfficeZipcode || ""}
                    onInputChange={(event, newInputValue) => {
                      setOfficeZipcode(newInputValue);
                    }}
                    value={valueO || null}
                    onChange={(event, newValue) => {
                      setValueO(newValue);
                      // setValueD(newValue)
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    renderInput={(params) => (
                      <Box
                        className="backgroundField"
                        sx={{ marginBottom: "10px" }}
                        ref={params.InputProps.ref}
                      >
                        <Input
                          type="text"
                          {...params.inputProps}
                          disableUnderline
                        />
                      </Box>
                    )}
                  />
                </div>
              </div>

              <hr class="chr" />
              {!mode ? (
                <>
                  <div class="row">
                    <div class="col-12">
                      <label class="title-content mb-4">
                        ชนิดพืช/พันธุ์
                        ที่ประสงค์จะขอเป็นตัวแทนจำหน่ายเมล็ดพันธุ์พืช เบื้องต้น
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-lg-6 col-md-12 table-responsive-sm pb-3"
                      style={{ height: "auto" }}
                    >
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col " style={{ width: "300px" }}>
                              ชนิดพืช
                            </th>
                            <th scope="col " style={{ width: "300px" }}>
                              พันธุ์
                            </th>
                            <th scope="col ">ปริมาณการขาย (ตัน/ปี)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <FormControl
                                variant="outlined"
                                size="small"
                                fullWidth
                              >
                                <Select
                                  value={ItemTypeName_1 || ""}
                                  onChange={(e) =>
                                    setItemTypeName_1(e.target.value)
                                  }
                                >
                                  {Types?.map((z, i) => (
                                    <MenuItem value={z?.TypeName}>
                                      {z?.TypeName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </td>
                            <td>
                              <FormControl
                                variant="outlined"
                                size="small"
                                fullWidth
                              >
                                <Select
                                  value={ItemCatalogName_1 || ""}
                                  onChange={(e) =>
                                    setItemCatalogName_1(e.target.value)
                                  }
                                >
                                  {Catalog?.map((z, i) => (
                                    <MenuItem value={z?.CatalogName}>
                                      {z?.CatalogName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </td>
                            <td>
                              <TextField
                                size="small"
                                value={ItemSaleAmount_1}
                                onChange={(e) =>
                                  setItemSaleAmount_1(e.target.value)
                                }
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                variant="outlined"
                                fullWidth
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <FormControl
                                variant="outlined"
                                size="small"
                                fullWidth
                              >
                                <Select
                                  value={ItemTypeName_2 || ""}
                                  onChange={(e) =>
                                    setItemTypeName_2(e.target.value)
                                  }
                                >
                                  {Types?.map((z, i) => (
                                    <MenuItem value={z?.TypeName}>
                                      {z?.TypeName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </td>
                            <td>
                              <FormControl
                                variant="outlined"
                                size="small"
                                fullWidth
                              >
                                <Select
                                  value={ItemCatalogName_2 || ""}
                                  onChange={(e) =>
                                    setItemCatalogName_2(e.target.value)
                                  }
                                >
                                  {Catalog?.map((z, i) => (
                                    <MenuItem value={z?.CatalogName}>
                                      {z?.CatalogName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </td>
                            <td>
                              <TextField
                                size="small"
                                value={ItemSaleAmount_2}
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                onChange={(e) =>
                                  setItemSaleAmount_2(e.target.value)
                                }
                                variant="outlined"
                                fullWidth
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <FormControl
                                variant="outlined"
                                size="small"
                                fullWidth
                              >
                                <Select
                                  value={ItemTypeName_3 || ""}
                                  onChange={(e) =>
                                    setItemTypeName_3(e.target.value)
                                  }
                                >
                                  {Types?.map((z, i) => (
                                    <MenuItem value={z?.TypeName}>
                                      {z?.TypeName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </td>
                            <td>
                              <FormControl
                                variant="outlined"
                                size="small"
                                fullWidth
                              >
                                <Select
                                  value={ItemCatalogName_3 || ""}
                                  onChange={(e) =>
                                    setItemCatalogName_3(e.target.value)
                                  }
                                >
                                  {Catalog?.map((z, i) => (
                                    <MenuItem value={z?.CatalogName}>
                                      {z?.CatalogName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </td>
                            <td>
                              <TextField
                                size="small"
                                value={ItemSaleAmount_3}
                                onChange={(e) =>
                                  setItemSaleAmount_3(e.target.value)
                                }
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                variant="outlined"
                                fullWidth
                              />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <FormControl
                                variant="outlined"
                                size="small"
                                fullWidth
                              >
                                <Select
                                  value={ItemTypeName_4 || ""}
                                  onChange={(e) =>
                                    setItemTypeName_4(e.target.value)
                                  }
                                >
                                  {Types?.map((z, i) => (
                                    <MenuItem value={z?.TypeName}>
                                      {z?.TypeName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </td>
                            <td>
                              <FormControl
                                variant="outlined"
                                size="small"
                                fullWidth
                              >
                                <Select
                                  value={ItemCatalogName_4 || ""}
                                  onChange={(e) =>
                                    setItemCatalogName_4(e.target.value)
                                  }
                                >
                                  {Catalog?.map((z, i) => (
                                    <MenuItem value={z?.CatalogName}>
                                      {z?.CatalogName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </td>
                            <td>
                              <TextField
                                size="small"
                                value={ItemSaleAmount_4}
                                onChange={(e) =>
                                  setItemSaleAmount_4(e.target.value)
                                }
                                onKeyPress={(event) => {
                                  if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                                variant="outlined"
                                fullWidth
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <hr class="chr" />
                  <div class="row">
                    <div class="col-6">
                      <label class="title-content mb-4">ไฟล์ที่แนบมา</label>
                    </div>
                  </div>
                  <div class="row w-100">
                    <div class="col-12  fixed-width">
                      <div class="sub-fixed-width">
                        <label class="labelInput">อัพโหลดสำเนาเอกสาร</label>
                        <div class="upload-file" style={{ display: "flex" }}>
                          <Box
                            className="backgroundField"
                            sx={{ marginBottom: "10px", width: "400px" }}
                          >
                            <FormControl fullWidth variant="standard">
                              <Select
                                value={typesFileSelected || ""}
                                onChange={(e) =>
                                  setTypesFileSelected(e.target.value)
                                }
                                disableUnderline
                              >
                                {TypesFile?.map((x) => (
                                  <MenuItem value={x?.value}>
                                    {x?.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Box>
                          <input
                            type="file"
                            ref={fileRef}
                            hidden
                            onChange={uploadFile}
                          />
                          <Button
                            variant="outlined"
                            onClick={() => fileRef.current.click()}
                            startIcon={<FontAwesomeIcon icon={faUpload} />}
                            sx={{
                              width: "150px",
                              fontSize: "16px",
                              margin: "10px",
                            }}
                          >
                            อัพโหลด
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div class="row">
                    <div class="col-6">
                      <label class="title-content">
                        ไฟล์ที่แนบมา ( สำหรับการต่ออายุ )
                      </label>
                      <Button
                        onClick={() => {
                          setAutoExpiredAgentExtFile(true);
                        }}
                        variant="outlined"
                        sx={{ width: "150px", marginLeft: "20px" }}
                        startIcon={<FontAwesomeIcon icon={faDownload} />}
                      >
                        ใช้ไฟล์จากระบบ
                      </Button>
                    </div>
                  </div>
                  <div class="row w-100 g-0 mb-4">
                    {AutoExpiredAgentExtFile && (
                      <div class="col-12  fixed-width">
                        <div class="row">
                          <div class="col-lg-6 col-sm-12">
                            <div
                              class="files-uploaded me-4 "
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "10px",
                              }}
                            >
                              <div
                                class="icon-file"
                                style={{ marginRight: "10px" }}
                              >
                                <img
                                  src={`/assets/icons/pdf.svg`}
                                  width="50px"
                                />
                              </div>
                              <div class="file-info" style={{ width: "100%" }}>
                                <div
                                  class="file-h1"
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "16px",
                                  }}
                                >
                                  สำเนาใบอนุญาตตัวแทนจำหน่ายเมล็ดพันธุ์พืช
                                  ของกรมข้าว ที่สิ้นอายุ *
                                </div>
                              </div>
                              <div
                                class="file-remove"
                                onClick={() => {
                                  setAutoExpiredAgentExtFile(false);
                                }}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  fontSize: "32px",
                                  color: "red",
                                  cursor: "pointer",
                                }}
                              >
                                <FontAwesomeIcon icon={faCircleXmark} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div class="row w-100">
                    <div class="col-12  fixed-width">
                      <div class="sub-fixed-width">
                        <label class="labelInput">อัพโหลดสำเนาเอกสาร</label>
                        <div class="upload-file" style={{ display: "flex" }}>
                          <Box
                            className="backgroundField"
                            sx={{ marginBottom: "10px", width: "400px" }}
                          >
                            <FormControl fullWidth variant="standard">
                              <Select
                                value={typesFileSelected || ""}
                                onChange={(e) =>
                                  setTypesFileSelected(e.target.value)
                                }
                                disableUnderline
                              >
                                {ExpireFile?.map((x) => (
                                  <MenuItem value={x?.value}>
                                    {x?.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Box>
                          <input
                            type="file"
                            ref={fileRef}
                            hidden
                            onChange={uploadFile}
                          />
                          <Button
                            variant="outlined"
                            onClick={() => fileRef.current.click()}
                            startIcon={<FontAwesomeIcon icon={faUpload} />}
                            sx={{
                              width: "150px",
                              fontSize: "16px",
                              margin: "10px",
                            }}
                          >
                            อัพโหลด
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

              <div class="row w-100 g-0">
                <div class="col-12  fixed-width">
                  <div class="row">
                    {file?.map((x, i) => (
                      <div class="col-lg-6 col-sm-12">
                        <div
                          class="files-uploaded me-4 "
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "10px",
                          }}
                        >
                          <div
                            class="icon-file"
                            style={{ marginRight: "10px" }}
                          >
                            <img src={`/${x?.pathImg}`} width="50px" />
                          </div>
                          <div class="file-info" style={{ width: "100%" }}>
                            <div
                              class="file-h1"
                              style={{ fontWeight: "600", fontSize: "16px" }}
                            >
                              {x?.typeDoc}
                            </div>
                            <div
                              class="file-d1"
                              style={{
                                fontWeight: "500",
                                fontSize: "14px",
                                lineBreak: "anywhere",
                                paddingRight: "10px",
                              }}
                            >
                              {x?.FileName}
                            </div>
                          </div>
                          {x?.UploadFileId && (
                            <Button
                              onClick={() => viewFile(x)}
                              variant="contained"
                              sx={{
                                marginRight: "10px",
                                width: "180px",
                                fontSize: "12px",
                                background: "#fbbe66",
                                ":hover": { background: "#eda844" },
                              }}
                              startIcon={<FontAwesomeIcon icon={faEye} />}
                            >
                              เรียกดู
                            </Button>
                          )}
                          {x?.UploadFileId && (
                            <Button
                              onClick={() => downloadFile(x)}
                              variant="contained"
                              sx={{
                                marginRight: "10px",
                                width: "180px",
                                fontSize: "12px",
                              }}
                              startIcon={<FontAwesomeIcon icon={faDownload} />}
                            >
                              ดาวน์โหลด
                            </Button>
                          )}
                          <div
                            class="file-remove"
                            onClick={() => {
                              if (x?.UploadFileId) {
                                setFilesRemove([
                                  ...filesRemove,
                                  x?.UploadFileId,
                                ]);
                                const remo = file?.filter(
                                  (y, index) => i !== index,
                                );
                                setFile(remo);
                              } else {
                                const remo = file?.filter(
                                  (y, index) => i !== index,
                                );
                                setFile(remo);
                              }
                            }}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              fontSize: "32px",
                              color: "red",
                              cursor: "pointer",
                            }}
                          >
                            <FontAwesomeIcon icon={faCircleXmark} />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <hr class="chr" />
              <div class="row mt-4">
                <div class="col-12">
                  <Button
                    onClick={() => navigate(-1)}
                    variant="outlined"
                    startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                    sx={{
                      width: "130px",
                      fontSize: "14px",
                      marginRight: "10px",
                    }}
                  >
                    กลับ
                  </Button>
                  {!detail ||
                  profile?.BranchNo?.BranchNo === detail?.BranchNo ||
                  profile?.BranchNo?.BranchNo === "00" ? (
                    <>
                      {(!mode && detail?.ExtentionStatus === "W") ||
                        (!detail && (
                          <>
                            {(detail?.Status !== "N" &&
                              detail?.Status !== "U") ||
                            !detail ? (
                              <Button
                                variant="contained"
                                sx={{
                                  width: "130px",
                                  fontSize: "14px",
                                  marginRight: "10px",
                                }}
                                disabled={submitLoading}
                                onClick={() => handleSubmit()}
                              >
                                {submitLoading ? (
                                  <CircularProgress
                                    size={"18px"}
                                    color="inherit"
                                  />
                                ) : (
                                  "บันทึก"
                                )}
                              </Button>
                            ) : null}
                          </>
                        ))}
                      {!mode && detail?.ExtentionStatus === "Y" && (
                        <>
                          {(detail?.Status === "W" ||
                            detail?.Status === "DR" ||
                            detail?.Status === "DU") &&
                            detail && (
                              <Button
                                variant="outlined"
                                sx={{ marginRight: "10px" }}
                                onClick={() => addon()}
                              >
                                ขอเอกสารเพิ่มเติม
                              </Button>
                            )}
                          {(detail?.Status !== "N" && detail?.Status !== "U") ||
                          !detail ? (
                            <Button
                              variant="contained"
                              sx={{
                                width: "130px",
                                fontSize: "14px",
                                marginRight: "10px",
                              }}
                              disabled={submitLoading}
                              onClick={() => handleSubmit()}
                            >
                              {id ? "เเก้ไข" : "บันทึก"}
                            </Button>
                          ) : null}
                          {(detail?.Status === "W" ||
                            detail?.Status === "DU") &&
                          detail ? (
                            <Button
                              variant="contained"
                              color="success"
                              sx={{
                                width: "130px",
                                fontSize: "14px",
                                marginRight: "10px",
                              }}
                              onClick={() => {
                                setApproverOpen(true);
                              }}
                            >
                              อนุมัติ
                            </Button>
                          ) : null}
                          {(detail?.Status === "W" ||
                            detail?.Status === "DU") &&
                          detail ? (
                            <Button
                              variant="contained"
                              color="error"
                              sx={{
                                width: "130px",
                                fontSize: "14px",
                                marginRight: "10px",
                              }}
                              onClick={() => handleSubmit("N")}
                            >
                              ไม่อนุมัติ
                            </Button>
                          ) : null}
                        </>
                      )}
                    </>
                  ) : null}
                  {mode && (
                    <>
                      {(detail?.Status === "Y" ||
                        detail?.Status === "DR" ||
                        detail?.Status === "DU") &&
                      detail &&
                      detail?.ExtentionStatus === "W" ? (
                        <Button
                          variant="outlined"
                          sx={{ marginRight: "10px" }}
                          onClick={() => addonExpire()}
                        >
                          ขอเอกสารเพิ่มเติม
                        </Button>
                      ) : null}
                      <Button
                        variant="contained"
                        sx={{
                          width: "130px",
                          fontSize: "14px",
                          marginRight: "10px",
                        }}
                        disabled={submitLoading}
                        onClick={() => handleSubmit()}
                      >
                        {submitLoading ? (
                          <CircularProgress size={"18px"} color="inherit" />
                        ) : (
                          "เเก้ไข"
                        )}
                      </Button>
                      {(mode &&
                        (detail?.Status === "Y" || detail?.Status === "DU")) ||
                      detail?.ExtentionStatus === "W" ? (
                        <Button
                          disabled={submitLoading}
                          variant="contained"
                          color="success"
                          sx={{
                            width: "130px",
                            fontSize: "14px",
                            marginRight: "10px",
                          }}
                          onClick={() => approveExpire("Y")}
                        >
                          {submitLoading ? (
                            <CircularProgress size={"18px"} color="inherit" />
                          ) : detail?.ExtentionStatus === "W" ? (
                            "อนุมัติการต่ออายุ"
                          ) : (
                            "ต่ออายุ"
                          )}
                        </Button>
                      ) : null}
                    </>
                  )}
                  {detail && (
                    <>
                      <Button
                        disabled={downloadFormAgent}
                        type="button"
                        onClick={handleClick}
                        className="ButtomSearch"
                        variant="contained"
                        sx={{
                          width: "110px",
                          height: "auto",
                          background: "#3364af57 0 0 no-repeat padding-box",
                          border: "1px solid #3364af57",
                          color: "#3364af",
                          fontWeight: "700",
                          borderRadius: "100px",
                          ":hover": {
                            background: "#3364af57 0 0 no-repeat padding-box",
                          },
                        }}
                      >
                        {downloadFormAgent ? (
                          <CircularProgress size={"18px"} color="inherit" />
                        ) : (
                          "พิมพ์"
                        )}
                      </Button>

                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                        PaperProps={{
                          style: {
                            width: 220,
                          },
                        }}
                      >
                        <MenuItem onClick={() => downLoadRegister()}>
                          ตจ.1
                        </MenuItem>

                        {detail?.Status === "Y" && (
                          <>
                            {mode && (
                              <MenuItem
                                onClick={() => downloadExtensionExpire()}
                              >
                                ตจ.2
                              </MenuItem>
                            )}
                            <MenuItem onClick={() => openDialogSigner(null)}>
                              ตจ.4 (ผู้อำนวยการ)
                            </MenuItem>
                            <MenuItem
                              onClick={() => openDialogSigner("รักษาการแทน")}
                            >
                              ตจ.4 (รักษาการแทน)
                            </MenuItem>
                            <MenuItem
                              onClick={() =>
                                openDialogSigner("รักษาการในตำแหน่ง")
                              }
                            >
                              ตจ.4 (รักษาการในตำแหน่ง)
                            </MenuItem>
                            <MenuItem
                              onClick={() => openDialogSigner("ทำหน้าที่")}
                            >
                              ตจ.4 (ทำหน้าที่ผู้อำนวยการ)
                            </MenuItem>
                          </>
                        )}
                      </Menu>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
      </Page>
      <DocumentAddon
        open={Addon}
        setOpen={setAddon}
        requestNo={detail?.RequestNo}
      />
      <DocumentAddonExpire
        open={AddonE}
        setOpen={setAddonE}
        requestNo={detail?.RequestNo}
      />
      <DialogSigner
        open={openS}
        setOpen={setOpenS}
        AgentNumber={detail?.AgentNumber}
        actFor={actFor}
        setdownloadFormAgent={setdownloadFormAgent}
        signer={signer}
        setSigner={setSigner}
        year={year}
        setYear={setYear}
      />
      <Dialog
        open={openConf}
        onClose={() => setOpenConf(false)}
        fullWidth
        maxWidth="xl"
      >
        <DialogContent>
          <div class="container-fluid">
            <div class="d-flex row align-items-center ">
              <div class="col-8 d-flex">
                <label
                  class="title-content mb-4 me-4"
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    color: "#3364af",
                  }}
                >
                  ข้อมูลตัวแทนจำหน่าย
                </label>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">เลขที่ตัวแทนจำหน่าย</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={agentNumber}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <FormControl disabled variant="standard" fullWidth>
                    <Select value={BranchNo || ""} disableUnderline>
                      {branchs?.map((x) => (
                        <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">เลขที่เอกสาร</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={refNo}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">วันที่อนุมัติ</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <MobileDatePicker
                    dayOfWeekFormatter={(day) => `${day}`}
                    value={approveDate}
                    onChange={(e) => setApproveDate(e)}
                    slotProps={{
                      textField: {
                        variant: "standard",
                        fullWidth: true,
                        InputProps: { disableUnderline: true, readOnly: true },
                        value: approveDate,
                      },
                    }}
                    slots={{
                      textField: BrowserInput,
                    }}
                  />
                </Box>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-8 col-md-12">
                <label class="labelInput">ประเภทบุคคล</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <FormControl variant="standard" fullWidth>
                    <Select readOnly value={personType || ""} disableUnderline>
                      <MenuItem value="บุคคลธรรมดา">บุคคลธรรมดา</MenuItem>
                      <MenuItem value="นิติบุคคล">นิติบุคคล</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">ประเภทนิติบุคคล</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={juristicPersonType || ""}
                    onChange={(e) => setJuristicPersonType(e.target.value)}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">นิติบุคคลเลขที่</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={juristicPersonId}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">ผู้มีอำนาจลงนามแทน</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={authorizedSignatory}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>

              <div class="col-lg-4 col-md-12">
                <label class="labelInput">วันที่จดทะเบียน</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <MobileDatePicker
                    dayOfWeekFormatter={(day) => `${day}`}
                    value={issuerDate}
                    onChange={(e) => setIssuerDate(e)}
                    slotProps={{
                      textField: {
                        variant: "standard",
                        fullWidth: true,
                        InputProps: { disableUnderline: true, readOnly: true },
                        value: issuerDate,
                      },
                    }}
                    slots={{
                      textField: BrowserInput,
                    }}
                  />
                </Box>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-8 col-md-12">
                <label class="labelInput">ชื่อร้านค้า</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={contactName}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
            </div>

            <div class="row" style={{ alignItems: "flex-end" }}>
              {gender === "อื่นๆ" && (
                <div class="col-lg-2 col-md-12">
                  <label class="labelInput">คำหน้าอื่นๆ</label>
                  <Box
                    className="backgroundField"
                    sx={{ marginBottom: "10px" }}
                  >
                    <TextField
                      value={textGender}
                      variant="standard"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                        readOnly: true,
                      }}
                    />
                  </Box>
                </div>
              )}
              <div class="col-lg-4">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <label class="labelInput me-4">ชื่อ </label>
                  <FormControl>
                    <RadioGroup
                      row
                      value={gender}
                      onChange={(e) => {
                        setGender(e.target.value);
                        if (e.target.value === "อื่นๆ") {
                          setTextGender("นาย");
                        } else {
                          setTextGender(e.target.value);
                        }
                      }}
                    >
                      <FormControlLabel
                        disabled
                        value="นาย"
                        control={<Radio size="small" />}
                        label="นาย"
                      />
                      <FormControlLabel
                        disabled
                        value="นาง"
                        control={<Radio size="small" />}
                        label="นาง"
                      />
                      <FormControlLabel
                        disabled
                        value="นางสาว"
                        control={<Radio size="small" />}
                        label="นางสาว"
                      />
                      <FormControlLabel
                        disabled
                        value="อื่นๆ"
                        control={<Radio size="small" />}
                        label="อื่นๆ"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={customerFName}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
              <div class="col-lg-4">
                <label class="labelInput">นามสกุล</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={customerLName}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">บัตรประจำตัวประชาชน</label>
                <Box className={`backgroundField`}>
                  <TextField
                    value={nationalityId}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                    inputProps={{ maxLength: 13 }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                </Box>
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">อีเมล</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={email}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">ออกให้ ณ อำเภอ/เขต</label>
                <Autocomplete
                  fullWidth
                  readOnly
                  options={locationsI || []}
                  getOptionLabel={(option) => option?.DistrictName}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.SubDistrictId}>
                      จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                      {option?.SubDistrictName} / {option?.Zipcode}
                    </Box>
                  )}
                  inputValue={IssuerDistrict || ""}
                  onInputChange={(event, newInputValue) => {
                    setIssuerDistrict(newInputValue);
                  }}
                  value={valueI || null}
                  onChange={(event, newValue) => {
                    setValueI(newValue);
                    // setValueD(newValue)
                  }}
                  renderInput={(params) => (
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                      ref={params.InputProps.ref}
                    >
                      <Input
                        type="text"
                        {...params.inputProps}
                        disableUnderline
                      />
                    </Box>
                  )}
                />
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">จังหวัด</label>
                <Autocomplete
                  fullWidth
                  readOnly
                  options={locationsI || []}
                  getOptionLabel={(option) => option?.ProvinceName}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.SubDistrictId}>
                      จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                      {option?.SubDistrictName} / {option?.Zipcode}
                    </Box>
                  )}
                  inputValue={IssuerProvince || ""}
                  onInputChange={(event, newInputValue) => {
                    setIssuerProvince(newInputValue);
                  }}
                  value={valueI || null}
                  onChange={(event, newValue) => {
                    setValueI(newValue);
                    // setValueD(newValue)
                  }}
                  renderInput={(params) => (
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                      ref={params.InputProps.ref}
                    >
                      <Input
                        type="text"
                        {...params.inputProps}
                        disableUnderline
                      />
                    </Box>
                  )}
                />
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">โทรศัพท์</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={tel}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">โทรสาร</label>

                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={fax}
                    onChange={(e) => setFax(e.target.value)}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">วันเกิด</label>
                <Box className={`backgroundField`}>
                  <MobileDatePicker
                    dayOfWeekFormatter={(day) => `${day}`}
                    value={BirthDate}
                    onChange={(e) => setBirthDate(e)}
                    slotProps={{
                      textField: {
                        variant: "standard",
                        fullWidth: true,
                        InputProps: { disableUnderline: true, readOnly: true },
                        value: BirthDate,
                        onBlur: onBlur,
                      },
                    }}
                    slots={{
                      textField: BrowserInput,
                    }}
                  />
                </Box>
              </div>
              <div class="col-lg-2 col-md-12">
                <label class="labelInput">อายุ</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={dayjs(new Date()).year() - dayjs(BirthDate).year()}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>

              <div class="col-lg-2 col-md-12">
                <label class="labelInput">สัญชาติ</label>
                <Box className={`backgroundField`}>
                  <TextField
                    value={Nationality}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
            </div>

            <hr class="chr" />

            <div class="d-flex row align-items-center ">
              <div class="col-6">
                <label
                  class="title-content mb-4"
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    color: "#3364af",
                  }}
                >
                  ที่อยู่ตามบัตรประชาชน
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">บ้านเลขที่</label>

                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={houseNumber}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">หมู่</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={moo}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">ตรอก/ซอย</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={alley}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">ถนน</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={address}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">ตำบล</label>
                <Autocomplete
                  fullWidth
                  readOnly
                  options={locations || []}
                  getOptionLabel={(option) => option?.SubDistrictName}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.SubDistrictId}>
                      จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                      {option?.SubDistrictName} / {option?.Zipcode}
                    </Box>
                  )}
                  inputValue={subDistrict || ""}
                  onInputChange={(event, newInputValue) => {
                    setSubDistrict(newInputValue);
                  }}
                  value={value || null}
                  onChange={(event, newValue) => {
                    setValue(newValue);
                    // setValueD(newValue)
                  }}
                  renderInput={(params) => (
                    <Box
                      className={`backgroundField`}
                      ref={params.InputProps.ref}
                    >
                      <Input
                        type="text"
                        {...params.inputProps}
                        disableUnderline
                      />
                    </Box>
                  )}
                />
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">อำเภอ</label>
                <Autocomplete
                  fullWidth
                  readOnly
                  options={locations || []}
                  getOptionLabel={(option) => option?.DistrictName}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.SubDistrictId}>
                      จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                      {option?.SubDistrictName} / {option?.Zipcode}
                    </Box>
                  )}
                  inputValue={district || ""}
                  onInputChange={(event, newInputValue) => {
                    setDistrict(newInputValue);
                  }}
                  value={value || null}
                  onChange={(event, newValue) => {
                    setValue(newValue);
                    // setValueD(newValue)
                  }}
                  renderInput={(params) => (
                    <Box
                      className={`backgroundField`}
                      ref={params.InputProps.ref}
                    >
                      <Input
                        type="text"
                        {...params.inputProps}
                        disableUnderline
                      />
                    </Box>
                  )}
                />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">จังหวัด</label>
                <Autocomplete
                  fullWidth
                  readOnly
                  options={locations || []}
                  getOptionLabel={(option) => option?.ProvinceName}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.SubDistrictId}>
                      จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                      {option?.SubDistrictName} / {option?.Zipcode}
                    </Box>
                  )}
                  inputValue={province || ""}
                  onInputChange={(event, newInputValue) => {
                    setProvince(newInputValue);
                  }}
                  value={value || null}
                  onChange={(event, newValue) => {
                    setValue(newValue);
                    // setValueD(newValue)
                  }}
                  renderInput={(params) => (
                    <Box
                      className={`backgroundField`}
                      ref={params.InputProps.ref}
                    >
                      <Input
                        type="text"
                        {...params.inputProps}
                        disableUnderline
                      />
                    </Box>
                  )}
                />
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">รหัสไปรษณีย์</label>
                <Autocomplete
                  fullWidth
                  readOnly
                  options={locations || []}
                  getOptionLabel={(option) => option?.Zipcode}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.SubDistrictId}>
                      จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                      {option?.SubDistrictName} / {option?.Zipcode}
                    </Box>
                  )}
                  inputValue={zipcode || ""}
                  onInputChange={(event, newInputValue) => {
                    setZipcode(newInputValue);
                  }}
                  value={value || null}
                  onChange={(event, newValue) => {
                    setValue(newValue);
                    // setValueD(newValue)
                  }}
                  renderInput={(params) => (
                    <Box
                      className={`backgroundField`}
                      ref={params.InputProps.ref}
                    >
                      <Input
                        type="text"
                        {...params.inputProps}
                        disableUnderline
                      />
                    </Box>
                  )}
                />
              </div>
            </div>

            <hr class="chr" />

            <div class="d-flex row align-items-center">
              <div class="col-6">
                <label
                  class="title-content mb-4 me-5"
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    color: "#3364af",
                  }}
                >
                  สถานที่จำหน่าย
                </label>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">โทรศัพท์</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={ShopTel}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">โทรสาร</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={ShopFax}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">บ้านเลขที่</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={ShopHouseNumber}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">หมู่</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={ShopMoo}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">ตรอก/ซอย</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={ShopAlley}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">ถนน</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={ShopAddress}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">ตำบล</label>
                <Autocomplete
                  fullWidth
                  readOnly
                  options={locationsS || []}
                  getOptionLabel={(option) => option?.SubDistrictName}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.SubDistrictId}>
                      จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                      {option?.SubDistrictName} / {option?.Zipcode}
                    </Box>
                  )}
                  inputValue={ShopSubDistrict || ""}
                  onInputChange={(event, newInputValue) => {
                    setShopSubDistrict(newInputValue);
                  }}
                  value={valueS || null}
                  onChange={(event, newValue) => {
                    setValueS(newValue);
                    // setValueD(newValue)
                  }}
                  renderInput={(params) => (
                    <Box
                      className={`backgroundField`}
                      ref={params.InputProps.ref}
                    >
                      <Input
                        type="text"
                        {...params.inputProps}
                        disableUnderline
                      />
                    </Box>
                  )}
                />
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">อำเภอ</label>
                <Autocomplete
                  fullWidth
                  readOnly
                  options={locationsS || []}
                  getOptionLabel={(option) => option?.DistrictName}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.SubDistrictId}>
                      จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                      {option?.SubDistrictName} / {option?.Zipcode}
                    </Box>
                  )}
                  inputValue={ShopDistrict || ""}
                  onInputChange={(event, newInputValue) => {
                    setShopDistrict(newInputValue);
                  }}
                  value={valueS || null}
                  onChange={(event, newValue) => {
                    setValueS(newValue);
                    // setValueD(newValue)
                  }}
                  renderInput={(params) => (
                    <Box
                      className={`backgroundField`}
                      ref={params.InputProps.ref}
                    >
                      <Input
                        type="text"
                        {...params.inputProps}
                        disableUnderline
                      />
                    </Box>
                  )}
                />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">จังหวัด</label>
                <Autocomplete
                  fullWidth
                  readOnly
                  options={locationsS || []}
                  getOptionLabel={(option) => option?.ProvinceName}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.SubDistrictId}>
                      จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                      {option?.SubDistrictName} / {option?.Zipcode}
                    </Box>
                  )}
                  inputValue={ShopProvince || ""}
                  onInputChange={(event, newInputValue) => {
                    setShopProvince(newInputValue);
                  }}
                  value={valueS || null}
                  onChange={(event, newValue) => {
                    setValueS(newValue);
                    // setValueD(newValue)
                  }}
                  renderInput={(params) => (
                    <Box
                      className={`backgroundField`}
                      ref={params.InputProps.ref}
                    >
                      <Input
                        type="text"
                        {...params.inputProps}
                        disableUnderline
                      />
                    </Box>
                  )}
                />
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">รหัสไปรษณีย์</label>
                <Autocomplete
                  fullWidth
                  readOnly
                  options={locationsS || []}
                  getOptionLabel={(option) => option?.Zipcode}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.SubDistrictId}>
                      จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                      {option?.SubDistrictName} / {option?.Zipcode}
                    </Box>
                  )}
                  inputValue={ShopZipcode || ""}
                  onInputChange={(event, newInputValue) => {
                    setShopZipcode(newInputValue);
                  }}
                  value={valueS || null}
                  onChange={(event, newValue) => {
                    setValueS(newValue);
                    // setValueD(newValue)
                  }}
                  renderInput={(params) => (
                    <Box
                      className={`backgroundField `}
                      sx={{ marginBottom: "10px" }}
                      ref={params.InputProps.ref}
                    >
                      <Input
                        type="text"
                        {...params.inputProps}
                        disableUnderline
                      />
                    </Box>
                  )}
                />
              </div>
            </div>
            <hr class="chr" />

            <div class="d-flex row align-items-center">
              <div class="col-6">
                <label
                  class="title-content mb-4 me-5"
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    color: "#3364af",
                  }}
                >
                  ที่อยู่สำนักงาน
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">โทรศัพท์</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={OfficeTel}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">โทรสาร</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={OfficeFax}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">บ้านเลขที่</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={OfficeHouseNumber}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">หมู่</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={OfficeMoo}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">ตรอก/ซอย</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={OfficeAlley}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">ถนน</label>
                <Box className="backgroundField" sx={{ marginBottom: "10px" }}>
                  <TextField
                    value={OfficeAddress}
                    variant="standard"
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      readOnly: true,
                    }}
                  />
                </Box>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">ตำบล</label>
                <Autocomplete
                  fullWidth
                  readOnly
                  options={locationsO || []}
                  getOptionLabel={(option) => option?.SubDistrictName}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.SubDistrictId}>
                      จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                      {option?.SubDistrictName} / {option?.Zipcode}
                    </Box>
                  )}
                  inputValue={OfficeSubDistrict || ""}
                  onInputChange={(event, newInputValue) => {
                    setOfficeSubDistrict(newInputValue);
                  }}
                  value={valueO || null}
                  onChange={(event, newValue) => {
                    setValueO(newValue);
                    // setValueD(newValue)
                  }}
                  renderInput={(params) => (
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                      ref={params.InputProps.ref}
                    >
                      <Input
                        type="text"
                        {...params.inputProps}
                        disableUnderline
                      />
                    </Box>
                  )}
                />
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">อำเภอ</label>
                <Autocomplete
                  fullWidth
                  readOnly
                  options={locationsO || []}
                  getOptionLabel={(option) => option?.DistrictName}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.SubDistrictId}>
                      จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                      {option?.SubDistrictName} / {option?.Zipcode}
                    </Box>
                  )}
                  inputValue={OfficeDistrict || ""}
                  onInputChange={(event, newInputValue) => {
                    setOfficeDistrict(newInputValue);
                  }}
                  value={valueO || null}
                  onChange={(event, newValue) => {
                    setValueO(newValue);
                    // setValueD(newValue)
                  }}
                  renderInput={(params) => (
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                      ref={params.InputProps.ref}
                    >
                      <Input
                        type="text"
                        {...params.inputProps}
                        disableUnderline
                      />
                    </Box>
                  )}
                />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">จังหวัด</label>
                <Autocomplete
                  fullWidth
                  readOnly
                  options={locationsO || []}
                  getOptionLabel={(option) => option?.ProvinceName}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.SubDistrictId}>
                      จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                      {option?.SubDistrictName} / {option?.Zipcode}
                    </Box>
                  )}
                  inputValue={OfficeProvince || ""}
                  onInputChange={(event, newInputValue) => {
                    setOfficeProvince(newInputValue);
                  }}
                  value={valueO || null}
                  onChange={(event, newValue) => {
                    setValueO(newValue);
                    // setValueD(newValue)
                  }}
                  renderInput={(params) => (
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                      ref={params.InputProps.ref}
                    >
                      <Input
                        type="text"
                        {...params.inputProps}
                        disableUnderline
                      />
                    </Box>
                  )}
                />
              </div>
              <div class="col-lg-4 col-md-12">
                <label class="labelInput">รหัสไปรษณีย์</label>
                <Autocomplete
                  fullWidth
                  readOnly
                  options={locationsO || []}
                  getOptionLabel={(option) => option?.Zipcode}
                  renderOption={(props, option) => (
                    <Box component="li" {...props} key={option.SubDistrictId}>
                      จ.{option?.ProvinceName} / อ.{option?.DistrictName} / ต.
                      {option?.SubDistrictName} / {option?.Zipcode}
                    </Box>
                  )}
                  inputValue={OfficeZipcode || ""}
                  onInputChange={(event, newInputValue) => {
                    setOfficeZipcode(newInputValue);
                  }}
                  value={valueO || null}
                  onChange={(event, newValue) => {
                    setValueO(newValue);
                    // setValueD(newValue)
                  }}
                  renderInput={(params) => (
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                      ref={params.InputProps.ref}
                    >
                      <Input
                        type="text"
                        {...params.inputProps}
                        disableUnderline
                      />
                    </Box>
                  )}
                />
              </div>
            </div>

            <hr class="chr" />
            <div class="row">
              <div class="col-12">
                <label class="title-content mb-4">
                  ชนิดพืช/พันธุ์ ที่ประสงค์จะขอเป็นตัวแทนจำหน่ายเมล็ดพันธุ์พืช
                  เบื้องต้น
                </label>
              </div>
            </div>
            <div class="row">
              <div
                class="col-lg-6 col-md-12 table-responsive-sm pb-3"
                style={{ height: "auto" }}
              >
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col " style={{ width: "300px" }}>
                        ชนิดพืช
                      </th>
                      <th scope="col " style={{ width: "300px" }}>
                        พันธุ์
                      </th>
                      <th scope="col ">ปริมาณการขาย (ตัน/ปี)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <FormControl variant="outlined" size="small" fullWidth>
                          <Select
                            readOnly
                            value={ItemTypeName_1 || ""}
                            onChange={(e) => setItemTypeName_1(e.target.value)}
                          >
                            {Types?.map((z, i) => (
                              <MenuItem value={z?.TypeName}>
                                {z?.TypeName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </td>
                      <td>
                        <FormControl variant="outlined" size="small" fullWidth>
                          <Select
                            readOnly
                            value={ItemCatalogName_1 || ""}
                            onChange={(e) =>
                              setItemCatalogName_1(e.target.value)
                            }
                          >
                            {Catalog?.map((z, i) => (
                              <MenuItem value={z?.CatalogName}>
                                {z?.CatalogName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </td>
                      <td>
                        <TextField
                          InputProps={{
                            readOnly: true,
                          }}
                          size="small"
                          value={ItemSaleAmount_1 || 0}
                          onChange={(e) => setItemSaleAmount_1(e.target.value)}
                          variant="outlined"
                          fullWidth
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <FormControl variant="outlined" size="small" fullWidth>
                          <Select
                            readOnly
                            value={ItemTypeName_2 || ""}
                            onChange={(e) => setItemTypeName_2(e.target.value)}
                          >
                            {Types?.map((z, i) => (
                              <MenuItem value={z?.TypeName}>
                                {z?.TypeName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </td>
                      <td>
                        <FormControl variant="outlined" size="small" fullWidth>
                          <Select
                            readOnly
                            value={ItemCatalogName_2 || ""}
                            onChange={(e) =>
                              setItemCatalogName_2(e.target.value)
                            }
                          >
                            {Catalog?.map((z, i) => (
                              <MenuItem value={z?.CatalogName}>
                                {z?.CatalogName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </td>
                      <td>
                        <TextField
                          InputProps={{ readOnly: true }}
                          size="small"
                          value={ItemSaleAmount_2 || 0}
                          onChange={(e) => setItemSaleAmount_2(e.target.value)}
                          variant="outlined"
                          fullWidth
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <FormControl variant="outlined" size="small" fullWidth>
                          <Select
                            readOnly
                            value={ItemTypeName_3 || ""}
                            onChange={(e) => setItemTypeName_3(e.target.value)}
                          >
                            {Types?.map((z, i) => (
                              <MenuItem value={z?.TypeName}>
                                {z?.TypeName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </td>
                      <td>
                        <FormControl variant="outlined" size="small" fullWidth>
                          <Select
                            readOnly
                            value={ItemCatalogName_3 || ""}
                            onChange={(e) =>
                              setItemCatalogName_3(e.target.value)
                            }
                          >
                            {Catalog?.map((z, i) => (
                              <MenuItem value={z?.CatalogName}>
                                {z?.CatalogName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </td>
                      <td>
                        <TextField
                          InputProps={{ readOnly: true }}
                          size="small"
                          value={ItemSaleAmount_3 || 0}
                          onChange={(e) => setItemSaleAmount_3(e.target.value)}
                          variant="outlined"
                          fullWidth
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <FormControl variant="outlined" size="small" fullWidth>
                          <Select
                            readOnly
                            value={ItemTypeName_4 || ""}
                            onChange={(e) => setItemTypeName_4(e.target.value)}
                          >
                            {Types?.map((z, i) => (
                              <MenuItem value={z?.TypeName}>
                                {z?.TypeName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </td>
                      <td>
                        <FormControl variant="outlined" size="small" fullWidth>
                          <Select
                            readOnly
                            value={ItemCatalogName_4 || ""}
                            onChange={(e) =>
                              setItemCatalogName_4(e.target.value)
                            }
                          >
                            {Catalog?.map((z, i) => (
                              <MenuItem value={z?.CatalogName}>
                                {z?.CatalogName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </td>
                      <td>
                        <TextField
                          InputProps={{ readOnly: true }}
                          size="small"
                          value={ItemSaleAmount_4 || 0}
                          onChange={(e) => setItemSaleAmount_4(e.target.value)}
                          variant="outlined"
                          fullWidth
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {!mode ? (
              <>
                <hr class="chr" />
                <div class="row">
                  <div class="col-6">
                    <label
                      class="title-content mb-4"
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "700",
                        color: "#3364af",
                      }}
                    >
                      ไฟล์ที่แนบมา
                    </label>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div class="row">
                  <div class="col-6">
                    <label
                      class="title-content mb-4"
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "700",
                        color: "#3364af",
                      }}
                    >
                      ไฟล์ที่แนบมา ( สำหรับการต่ออายุ )
                    </label>
                  </div>
                </div>
              </>
            )}

            <div class="row w-100 g-0">
              <div class="col-12  fixed-width">
                <div class="row">
                  {file?.map((x, i) => (
                    <div class="col-lg-6 col-sm-12">
                      <div
                        class="files-uploaded me-4 "
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px",
                        }}
                      >
                        <div class="icon-file" style={{ marginRight: "10px" }}>
                          <img src={`/${x?.pathImg}`} width="50px" />
                        </div>
                        <div class="file-info" style={{ width: "100%" }}>
                          <div
                            class="file-h1"
                            style={{ fontWeight: "600", fontSize: "16px" }}
                          >
                            {x?.typeDoc}
                          </div>
                          <div
                            class="file-d1"
                            style={{
                              fontWeight: "500",
                              fontSize: "14px",
                              lineBreak: "anywhere",
                              paddingRight: "10px",
                            }}
                          >
                            {x?.FileName}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <hr class="chr" />
            <div class="row mt-4">
              <div class="col-12 text-end">
                <Button
                  onClick={() => setOpenConf(false)}
                  variant="outlined"
                  sx={{ width: "150px", marginRight: "20px" }}
                >
                  ยกเลิก
                </Button>
                <Button
                  disabled={submitLoading}
                  onClick={() => {
                    setOpenConf(false);
                    agentAdd(stateFormData, id);
                  }}
                  variant="contained"
                  sx={{ width: "150px", marginRight: "20px" }}
                >
                  ยืนยันการทำรายการ
                </Button>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog open={approverOpen} fullWidth maxWidth="md">
        <DialogContent>
          <div class="container">
            <div class="row w-100">
              <div class="col-sm-12 d-flex justify-content-between">
                <label
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    color: "#3364af",
                    marginBottom: "10px",
                  }}
                >
                  ช่องทางติดต่อเจ้าหน้าที่
                </label>
              </div>
            </div>

            <div class="col-md-12 mt-4 mb-4">
              <div>
                <div style={{ marginBottom: "20px" }}>
                  <TextField
                    error={approverNameError}
                    fullWidth
                    placeholder="ระบุชื่อเจ้าหน้าที่"
                    value={approverName}
                    onChange={(e) => {
                      setApproverNameError(false);
                      setApproverName(e.target.value);
                    }}
                    variant="outlined"
                  />
                </div>
                <div>
                  <TextField
                    error={approverTelError}
                    fullWidth
                    placeholder="หมายเลขติดต่อ"
                    value={approverTel}
                    onChange={(e) => {
                      setApproverTelError(false);
                      setApproverTel(e.target.value);
                    }}
                    variant="outlined"
                  />
                </div>
              </div>
            </div>

            <div class="row w-100">
              <div class="col-12 " style={{ textAlign: "right" }}>
                <Button
                  onClick={() => {
                    handleSubmit("Y");
                  }}
                  variant="contained"
                  sx={{ width: "150px", marginRight: "20px" }}
                >
                  ยืนยันการทำรายการ
                </Button>
                <Button
                  onClick={() => {
                    setApproverOpen();
                    setApproverName("");
                    setApproverTel("");
                    setApproverNameError(false);
                    setApproverTelError(false);
                  }}
                  variant="outlined"
                  sx={{ width: "150px", marginRight: "20px" }}
                >
                  ยกเลิก
                </Button>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
